{
  "common": {
    "loading": "Loading…",
    "retry": "Retry",
    "cancel": "Cancel",
    "close": "Close",
    "back": "Back",
    "logout": "Sign out",
    "or": "or",
    "home": "Home",
    "poweredBy": "Powered by {{product}}",
    "academicYear": "Academic year {{year}}",
    "save": "Save",
    "edit": "Edit",
    "delete": "Delete",
    "all": "All",
    "reset": "Reset",
    "columns": "Columns",
    "export": "Export",
    "actions": "Actions",
    "saving": "Saving…",
    "saved": "Saved",
    "phaseSoon": "Available in phase {{phase}}"
  },
  "languages": {
    "fr": "Français",
    "ar": "العربية",
    "en": "English",
    "short": {
      "fr": "FR",
      "ar": "العربية",
      "en": "EN"
    }
  },
  "roles": {
    "SUPER_ADMIN": "Platform super-admin",
    "ADMIN_ECOLE": "Administration",
    "AGENT_SCOLARITE": "Registrar officer",
    "AGENT_FINANCE": "Finance officer",
    "ENSEIGNANT": "Teacher",
    "ETUDIANT": "Student",
    "CANDIDAT": "Applicant"
  },
  "auth": {
    "heroTitle": "Your student records space",
    "heroText": "Enrolments, grades, absences, payments and official documents — in one place, for the whole team and every student.",
    "title": "Sign in",
    "subtitle": "Use your institutional e-mail or your student ID.",
    "identifier": "E-mail or student ID",
    "password": "Password",
    "showPassword": "Show password",
    "hidePassword": "Hide password",
    "remember": "Stay signed in",
    "forgot": "Forgot password?",
    "submit": "Sign in",
    "submitting": "Signing in…",
    "sso": "Continue with single sign-on (SSO)",
    "ssoShort": "SSO sign-in",
    "ssoInfo": "Single sign-on will be available once your institution has configured it.",
    "newCandidate": "New applicant?",
    "applyLink": "Submit a pre-registration",
    "footer": "© {{year}} {{institution}}",
    "privacy": "Privacy",
    "help": "Help",
    "forgotSent": "If an account matches “{{identifier}}”, a reset link has just been sent.",
    "forgotNeedIdentifier": "Enter your e-mail or student ID first.",
    "errors": {
      "identifierRequired": "Enter your e-mail or student ID.",
      "passwordRequired": "Enter your password.",
      "invalidCredentials": "Incorrect e-mail, student ID or password.",
      "locked": "Too many attempts: your account is locked for 15 minutes.",
      "rateLimited": "Too many attempts. Try again in a minute.",
      "generic": "Unable to sign in. Check your network and try again.",
      "passwordTooShort": "The password must be at least {{min}} characters long.",
      "passwordMismatch": "Passwords do not match.",
      "passwordUnchanged": "The new password must differ from the current one."
    },
    "reset": {
      "title": "New password",
      "subtitle": "Choose a password of at least {{min}} characters.",
      "password": "New password",
      "confirm": "Confirm password",
      "submit": "Save password",
      "submitting": "Saving…",
      "done": "Password changed. You can now sign in.",
      "invalid": "This link is invalid or has expired. Request a new one from the sign-in page.",
      "backToLogin": "Back to sign in"
    },
    "identifierPlaceholder": "e.g. 24GL0137 or firstname.lastname@…",
    "features": {
      "notes": "LMD grades, juries and transcripts",
      "absences": "Mobile roll call and absence monitoring",
      "finance": "Payment schedules, payments and receipts",
      "documents": "Official documents verifiable by QR code"
    },
    "forgotTitle": "Forgot your password",
    "forgotText": "Enter your e-mail or student number: if an account matches, you will receive a link to choose a new password.",
    "forgotSubmit": "Send the link",
    "platform": {
      "heroTitle": "Platform console",
      "heroText": "Create schools, invite their administrators and manage their access. School data stays in each school's own space.",
      "features": {
        "schools": "Schools and their own addresses",
        "invites": "Administrator invitations",
        "suspend": "Suspension and reactivation",
        "restricted": "Restricted to the platform team"
      },
      "subtitle": "Restricted to the platform team. Sign in with your e-mail.",
      "identifier": "E-mail",
      "identifierPlaceholder": "name@…"
    }
  },
  "shell": {
    "menu": "Menu",
    "productLine": "{{product}} · {{space}}",
    "search": "Search a student, national ID, student ID…",
    "searchShortcut": "Ctrl K",
    "lightTheme": "Light theme",
    "darkTheme": "Dark theme",
    "notifications": "Notifications",
    "notificationsCount_one": "{{count}} unread notification",
    "notificationsCount_other": "{{count}} unread notifications",
    "noNotifications": "No notifications.",
    "markAllRead": "Mark all as read",
    "language": "Language",
    "year": "Academic year",
    "account": "Account",
    "skipToContent": "Skip to content",
    "space": {
      "scolarite": "Student records",
      "finance": "Finance",
      "teaching": "Teacher space"
    }
  },
  "yearStatus": {
    "draft": "Draft",
    "current": "Current",
    "closed": "Closed",
    "archived": "Archived"
  },
  "nav": {
    "groups": {
      "pilotage": "Overview",
      "admissions": "Admissions",
      "scolarite": "Student records",
      "evaluation": "Assessment",
      "finance": "Finance",
      "administration": "Administration"
    },
    "items": {
      "dashboard": "Dashboard",
      "preinscriptions": "Pre-registrations",
      "candidatures": "Applications",
      "students": "Students",
      "teachers": "Teachers",
      "curriculum": "Programmes",
      "timetable": "Timetable",
      "absences": "Absences",
      "grades": "Grade entry",
      "rollCall": "Take attendance",
      "deliberations": "Exam boards",
      "documents": "Transcripts & certificates",
      "schedules": "Payment schedules",
      "unpaid": "Unpaid fees",
      "settings": "Settings",
      "announcements": "Announcements",
      "audit": "Audit trail",
      "calendar": "Calendar",
      "internships": "Internships"
    }
  },
  "palette": {
    "label": "Global search",
    "placeholder": "Name, national ID, student ID or page…",
    "escape": "Esc",
    "students": "Students",
    "pages": "Pages",
    "noStudent": "No student matches “{{q}}”.",
    "meta": "{{matricule}} · ID {{cin}}",
    "level": "{{level}} · Group {{group}}"
  },
  "comingSoon": {
    "title": "Module in preparation",
    "text": "This screen ships in phase {{phase}}. Navigation, access rights and search already work."
  },
  "dashboard": {
    "greeting": "Hello {{name}} — {{date}}.",
    "greetingWeek": "Hello {{name}} — activity of {{date}}, week {{week}}.",
    "newEnrollment": "New enrolment",
    "kpi": {
      "students": "Enrolled students",
      "vsPrevious": "vs previous year",
      "applications": "Pending applications",
      "staleNote": "unanswered for {{days}}+ days",
      "paymentRate": "Payment rate",
      "ofDue": "of {{amount}} due",
      "absences": "Absences this week",
      "nearCount_one": "{{count}} student",
      "nearCount_other": "{{count}} students",
      "nearNote": "close to the exclusion threshold"
    },
    "programs": {
      "title": "Enrolments by programme",
      "subtitle": {
        "all": "Enrolled / programme capacity (all years) · {{year}}",
        "first": "First-year enrolled / intake places · {{year}}",
        "upper": "Second year and above / remaining places · {{year}}"
      },
      "first": "1st year",
      "upper": "2nd year +",
      "fill": "Fill rate:",
      "total": "Total enrolled:"
    },
    "todo": {
      "title": "To do",
      "count_one": "{{count}} item",
      "count_other": "{{count}} items",
      "juries": {
        "title": "Juries to hold",
        "meta": "Main-session juries not closed",
        "action": "Open"
      },
      "incompleteApplications": {
        "title": "Incomplete applications",
        "meta": "Required documents missing or rejected",
        "action": "View"
      },
      "staleApplications": {
        "title": "Unanswered applications",
        "meta": "Past the delay announced to candidates",
        "action": "Review"
      },
      "pendingCheques": {
        "title": "Cheques to clear",
        "meta": "Cheque payments pending",
        "action": "Handle"
      },
      "timetableConflicts": {
        "title": "Timetable conflicts",
        "meta": "Rooms, teachers or groups double-booked this semester",
        "action": "Resolve"
      }
    },
    "payments": {
      "title": "Latest payments",
      "all": "See all payments",
      "columns": {
        "student": "Student",
        "matricule": "ID",
        "installment": "Instalment",
        "mode": "Method",
        "amount": "Amount",
        "date": "Date",
        "status": "Status"
      }
    }
  },
  "errors": {
    "notFoundTitle": "Page not found",
    "notFoundText": "The requested address does not exist or has moved.",
    "forbiddenTitle": "Access denied",
    "forbiddenText": "Your role does not give access to this page. Contact the administration if needed.",
    "tenantNotFoundTitle": "Institution not found",
    "tenantNotFoundText": "Check the address: each institution has its own address, for example school.{{domain}}.",
    "loadFailedTitle": "Unable to load data",
    "loadFailedText": "Check your connection and try again. If the problem persists, contact support.",
    "goHome": "Back to home",
    "actionFailed": "That did not work. Please try again in a moment."
  },
  "student": {
    "hello": "Hello,",
    "offline": "Offline · data from {{date}}",
    "offlineEmpty": "Offline. Sign in once online to read your data without a network.",
    "nav": {
      "label": "Main navigation",
      "home": "Home",
      "notes": "Grades",
      "edt": "Timetable",
      "pay": "Payments",
      "more": "More"
    },
    "home": {
      "next": "Next class",
      "now": "now",
      "inMinutes": "in {{n}} min",
      "todayAt": "today at {{time}}",
      "noNext": "No upcoming class",
      "average": "S{{n}} average",
      "noAverage": "No average yet",
      "allPaid": "All paid",
      "absences": "absent",
      "absencesToJustify": "absent · {{hours}} to justify",
      "documents_one": "document available",
      "documents_other": "documents available",
      "seeAll": "See all",
      "announcementsAria_one": "Announcements, {{count}} unread",
      "announcementsAria_other": "Announcements, {{count}} unread",
      "documents_zero": "documents available"
    },
    "more": {
      "abs": "Absences",
      "docs": "Documents",
      "ann": "Announcements",
      "cal": "Calendar",
      "stages": "Internships"
    },
    "notes": {
      "title": "My grades",
      "semesters": "Semesters",
      "semester": "Semester {{n}}",
      "average": "Semester average",
      "provisional": "Provisional",
      "provisionalHint": "Provisional results: the decision is published after the board.",
      "credits_one": "{{count}} credit",
      "credits_other": "{{count}} credits",
      "coef": "Coef. {{coef}}",
      "compensated": "compensated",
      "emptyTitle": "No grades yet",
      "emptyText": "Your grades will appear here once published.",
      "semesterShort": "S{{n}}"
    },
    "week": {
      "days": "Days of the week",
      "empty": "No class this day."
    },
    "pay": {
      "title": "Payments",
      "paidOf": "Paid out of {{total}}",
      "progress": "Share of fees paid",
      "pending": "{{amount}} being cleared",
      "due": "Due {{date}}",
      "emptyTitle": "No payment schedule",
      "emptyText": "Your schedule will appear here once you are enrolled."
    },
    "abs": {
      "summary": "{{hours}} absent · {{justified}} justified",
      "status": {
        "justified": "Justified",
        "pending": "Under review",
        "unjustified": "Not justified"
      },
      "send": "Send a justification",
      "sheetTitle": "Send a justification",
      "alsoCover": "Also covers",
      "photo": "Take a photo of the document",
      "photoHint": "Photo, JPG, PNG or PDF · 5 MB max",
      "change": "Tap to change the file",
      "submit": "Send to the registrar",
      "sent": "Justification sent to the registrar.",
      "failed": "Could not send. Try again.",
      "badType": "Unsupported format: JPG, PNG or PDF.",
      "emptyTitle": "No absences",
      "emptyText": "You have no absences this year."
    },
    "docs": {
      "download": "Download {{name}}",
      "empty": "No document available yet.",
      "request": "Request a document",
      "requestHint": "Attendance certificate, internship…",
      "kind": "Document type",
      "note": "Details (optional)",
      "notePlaceholder": "E.g. for social security, two copies",
      "send": "Send request",
      "requested": "Request sent to the registrar.",
      "duplicate": "A request of this type is already in progress.",
      "failed": "Could not send. Try again.",
      "myRequests": "My requests"
    },
    "requestKinds": {
      "enrollment_certificate": "Enrollment certificate",
      "attendance_certificate": "Attendance certificate",
      "transcript": "Transcript",
      "internship": "Internship agreement",
      "other": "Other document"
    },
    "requestStatus": {
      "pending": "In progress",
      "done": "Done",
      "rejected": "Rejected"
    },
    "ann": {
      "empty": "No announcements yet."
    },
    "cal": {
      "empty": "No upcoming date.",
      "showPast_one": "Show {{count}} past date",
      "showPast_other": "Show {{count}} past dates",
      "hidePast": "Hide past dates"
    },
    "stages": {
      "empty": "No internship this year.",
      "emptyText": "Declare your internship once the company has accepted you: the registrar approves the subject and the agreement appears in your documents.",
      "declare": "Declare an internship",
      "declareHint": "The registrar approves the subject. You can propose a supervisor: they will get a request.",
      "editTitle": "Edit my internship",
      "send": "Send for approval",
      "askSupervisor": "Propose a supervisor",
      "askSupervisorHint": "The chosen teacher gets your request and accepts or refuses it.",
      "sendRequest": "Send the request",
      "convention": "Your internship agreement is in More › Documents."
    }
  },
  "candidate": {
    "title": "Track your application",
    "comingSoonText": "Detailed tracking of your pre-registration file will be available here (phase 4)."
  },
  "platform": {
    "title": "Institutions",
    "subtitle": "Platform console · {{count}} institutions",
    "columns": {
      "name": "Institution",
      "slug": "Address",
      "status": "Status",
      "users": "Accounts",
      "students": "Students",
      "createdAt": "Created"
    },
    "status": {
      "active": "Active",
      "suspended": "Suspended"
    },
    "create": "New institution",
    "suspend": "Suspend",
    "reactivate": "Reactivate",
    "reinvite": "Resend invitation",
    "created": "Institution created. The invitation was sent.",
    "suspended": "Institution suspended.",
    "reactivated": "Institution reactivated.",
    "reinvited": "Invitation resent.",
    "suspendTitle": "Suspend {{name}}?",
    "suspendText": "Users of this institution will no longer be able to sign in.",
    "fields": {
      "slug": "Address (slug)",
      "name": "Legal name",
      "shortName": "Short name",
      "color": "Primary colour",
      "firstName": "Administrator first name",
      "lastName": "Administrator last name",
      "email": "Administrator e-mail",
      "yearLabel": "First year",
      "startsOn": "Start",
      "s1EndsOn": "End of semester 1",
      "s2EndsOn": "End of semester 2",
      "endsOn": "End of year",
      "slugHelp": "Lowercase letters, digits and dashes (3 to 32). Example: esprit."
    },
    "errors": {
      "generic": "Operation refused.",
      "slug": "Invalid address: letters, digits and hyphens, 3 to 32 characters.",
      "slugReserved": "This address is reserved.",
      "required": "Required.",
      "shortName": "12 characters at most.",
      "email": "Invalid e-mail address."
    },
    "documentTitle": "Console · {{product}}",
    "scope": "Platform console",
    "kpi": {
      "schools": "Schools",
      "active_one": "{{count}} active",
      "active_other": "{{count}} active",
      "suspended": "Suspended",
      "users": "Accounts",
      "students": "Students"
    },
    "empty": "No school yet. Create the first one with « New school ».",
    "sheet": {
      "label": "School details",
      "address": "Address",
      "createdOn": "Created on {{date}}",
      "accounts": "Accounts by role",
      "noAccounts": "No account.",
      "admins": "Administrators",
      "noAdmin": "No administrator.",
      "lastLogin": "Last signed in on {{date}}",
      "neverLoggedIn": "Never signed in",
      "open": "Open the school",
      "studentRecords": "Student records"
    },
    "adminState": {
      "invited": "Invitation pending",
      "active": "Active",
      "disabled": "Disabled"
    },
    "reinviteTitle": "Resend the invitation?",
    "reinviteText": "A new link will be sent to {{email}}. Links sent earlier stay valid until they expire.",
    "nav": {
      "label": "Console sections",
      "schools": "Schools",
      "journal": "Log"
    },
    "journalSubtitle": "Schools created, suspended, reactivated, invitations resent and console password changes."
  },
  "public": {
    "applyTitle": "Online pre-registration",
    "applyText": "The public pre-registration form will be available here (phase 4)."
  },
  "enrollmentStatus": {
    "en_cours": "Enrolled",
    "en_cours_F": "Enrolled",
    "admis": "Passed",
    "admis_F": "Passed",
    "ajourne": "Failed",
    "ajourne_F": "Failed",
    "abandon": "Withdrawn",
    "abandon_F": "Withdrawn",
    "none": "Not enrolled",
    "none_F": "Not enrolled",
    "current": "In progress"
  },
  "students": {
    "title": "Students",
    "subtitle": "{{count}} students · year {{year}}",
    "new": "New student",
    "search": "Name, national ID or student ID",
    "filters": {
      "program": "Programme",
      "level": "Level",
      "group": "Group",
      "status": "Status",
      "allPrograms": "All programmes",
      "allLevels": "All levels",
      "allGroups": "All groups",
      "allStatuses": "All statuses"
    },
    "columns": {
      "matricule": "Student ID",
      "name": "Name",
      "program": "Programme",
      "level": "Level",
      "group": "Group",
      "status": "Status"
    },
    "selection_one": "{{count}} student selected",
    "selection_other": "{{count}} students selected",
    "clearSelection": "Clear selection",
    "changeGroup": "Change group",
    "changeGroupHint": "Select students of the same level to change their group.",
    "changeGroupTitle": "Change group · {{count}} student(s)",
    "groupChanged": "{{count}} student(s) moved to group {{group}}.",
    "openRecord": "Open record",
    "emptyTitle": "No students match these filters",
    "emptyText": "Change the criteria or reset the search to show all students.",
    "errors": {
      "required": "Required field.",
      "cin": "The national ID must have 8 digits.",
      "email": "Invalid e-mail address.",
      "phone": "Invalid phone number.",
      "date": "Invalid date.",
      "average": "The average must be between 0 and 20.",
      "level": "Choose a level.",
      "duplicateCin": "A student with this national ID already exists.",
      "save": "Could not save. Check the fields and try again."
    },
    "import": {
      "open": "Import",
      "title": "Import students · {{year}}",
      "intro": "One row per student. Last name, first name and level are required; the other template columns are optional. A student already known (same student ID or CIN) is not changed: they are only enrolled for the year.",
      "pick": "Choose an Excel file (.xlsx)",
      "hint": "or drop it here · 2,000 rows at most",
      "analysing": "Reading the file…",
      "detected_one": "{{formatted}} row read",
      "detected_other": "{{formatted}} rows read",
      "template": "Download the template",
      "apply_one": "Import {{count}} student",
      "apply_other": "Import {{count}} students",
      "applied": "Import complete.",
      "toCreate_one": "{{count}} new student will be created and enrolled",
      "toCreate_other": "{{count}} new students will be created and enrolled",
      "created_one": "{{count}} student created and enrolled",
      "created_other": "{{count}} students created and enrolled",
      "toEnroll_one": "{{count}} known student will be enrolled for the year",
      "toEnroll_other": "{{count}} known students will be enrolled for the year",
      "enrolled_one": "{{count}} known student enrolled for the year",
      "enrolled_other": "{{count}} known students enrolled for the year",
      "skipped_one": "{{count}} student already enrolled this year: skipped",
      "skipped_other": "{{count}} students already enrolled this year: skipped",
      "rejected_one": "{{count}} row to fix: it will not be imported",
      "rejected_other": "{{count}} rows to fix: they will not be imported",
      "invited_one": "{{count}} access e-mail sent",
      "invited_other": "{{count}} access e-mails sent",
      "invite": "Send student-space access to the students created (those with an e-mail)",
      "done": "{{created}} created, {{enrolled}} enrolled",
      "line": "Row",
      "problem": "To fix",
      "errors": {
        "file": "This file cannot be read. Save it as an Excel file (.xlsx) and try again.",
        "columns": "Columns not found: the first row must contain at least Nom, Prénom and Niveau. Start from the template.",
        "empty": "The file contains no student.",
        "too_many": "More than 2,000 rows: split the file (by programme or level).",
        "year_closed": "This academic year is closed: choose the current year.",
        "size": "File too large (1 MB at most)."
      },
      "rowErrors": {
        "required": "required",
        "level": "unknown level (see the Listes sheet of the template)",
        "group": "unknown group for this level and year",
        "matricule": "unknown student ID",
        "duplicate": "duplicated in the file",
        "cin_taken": "CIN already used by a teacher",
        "duplicate_cin": "CIN already used",
        "date": "invalid date (dd/mm/yyyy)",
        "gender": "F or M",
        "number": "invalid number",
        "cin": "8 digits",
        "email": "invalid e-mail",
        "phone": "invalid phone",
        "average": "average between 0 and 20",
        "already_enrolled": "already enrolled this year",
        "year_closed": "year closed",
        "internal": "unexpected error",
        "invalid": "invalid value",
        "other_student": "belongs to another student ({{ref}}): check the name or the number"
      },
      "homonyms_one": "{{count}} namesake to check",
      "homonyms_other": "{{count}} namesakes to check",
      "homonymLine": "Row {{row}} · {{name}}: same name as {{ref}}. If it is the same person, give their student ID to enrol them instead of creating a new record."
    },
    "access": {
      "action": "Send access",
      "title_one": "Send student-space access",
      "title_other": "Send access to {{count}} students",
      "text": "Each student gets their login (student ID) by e-mail and a link to choose a password, valid {{days}} days. Students without an e-mail address get nothing.",
      "confirm": "Send",
      "sent_one": "{{count}} e-mail sent",
      "sent_other": "{{count}} e-mails sent",
      "withoutEmail_one": "{{count}} student without e-mail",
      "withoutEmail_other": "{{count}} students without e-mail"
    }
  },
  "record": {
    "crumb": "Student records",
    "tabs": {
      "info": "Details",
      "enrollments": "Enrolments",
      "grades": "Grades",
      "absences": "Absences",
      "finance": "Finance",
      "documents": "Documents",
      "history": "History"
    },
    "attest": "Enrolment certificate",
    "releve": "Transcript",
    "statusLine": "{{status}} · {{year}}",
    "groupLine": "{{level}} · Group {{group}}",
    "cycle": {
      "ingenieur": "Engineering cycle",
      "licence": "Bachelor",
      "master": "Master"
    },
    "facts": {
      "average": "Average",
      "credits": "Credits validated (jury)",
      "absences": "Absences {{year}}",
      "balance": "Balance due",
      "averageSem": "S{{n}} average"
    },
    "sections": {
      "identity": "Identity",
      "contact": "Contact",
      "bac": "Baccalaureate",
      "guardian": "Guardian"
    },
    "fields": {
      "lastName": "Last name",
      "firstName": "First name",
      "lastNameAr": "Last name (Arabic)",
      "firstNameAr": "First name (Arabic)",
      "cin": "National ID",
      "gender": "Gender",
      "birthDate": "Date of birth",
      "birthPlace": "Place of birth",
      "nationality": "Nationality",
      "email": "E-mail",
      "phone": "Phone",
      "address": "Address",
      "city": "City",
      "bacSection": "Stream",
      "bacSession": "Session",
      "bacYear": "Year",
      "bacAverage": "Average",
      "bacSchool": "High school",
      "guardianName": "Name",
      "guardianRelation": "Relationship",
      "guardianPhone": "Phone",
      "guardianProfession": "Occupation"
    },
    "genders": {
      "F": "Female",
      "M": "Male"
    },
    "editTitle": "Edit · {{section}}",
    "saved": "Record updated.",
    "enrollmentsHead": {
      "year": "Year",
      "level": "Level",
      "group": "Group",
      "date": "Enrolled on",
      "credits": "Credits",
      "decision": "Decision"
    },
    "newEnrollment": "New enrolment",
    "enrollTitle": "Enrolment {{year}}",
    "enrolled": "Enrolment saved.",
    "changeGroup": "Change group",
    "groupChanged": "Group changed.",
    "noGroup": "No group",
    "alreadyEnrolled": "The student is already enrolled for this year.",
    "comingTitle": "Coming soon",
    "comingText": "This tab will be filled in phase {{phase}}.",
    "historyEmpty": "No events recorded.",
    "grades": {
      "empty": "No marks yet",
      "semester": "S{{n}} · {{year}}",
      "semAvg": "Semester average:",
      "live": "Provisional results computed from the marks entered (before the board).",
      "frozen": "Results set by the board · {{session}}.",
      "notPublished": "Results will be visible once the minutes are published.",
      "head": {
        "unit": "Unit / course",
        "coef": "Coef.",
        "credits": "Credits",
        "average": "Average",
        "result": "Result"
      },
      "acq": "Passed",
      "comp": "Compensated",
      "nacq": "Not passed"
    },
    "notFoundTitle": "Student not found",
    "notFoundText": "This record does not exist, was deleted, or is outside your scope."
  },
  "history": {
    "student_create": "Record created (student ID {{matricule}})",
    "student_update": "Record changed: {{fields}}",
    "enrollment_create": "Enrolment in {{level}} confirmed ({{year}})",
    "enrollment_group_change": "Group changed: group {{group}}",
    "enrollment_update": "Enrolment updated",
    "unknown": "Event: {{action}}",
    "meta": "{{date}} · {{actor}}",
    "system": "System",
    "document_issue": "{{typeLabel}} issued · {{code}}",
    "document_revoke": "Document revoked: {{reason}}",
    "document_send": "Document e-mailed to the student",
    "jury_decision": "Board decision changed: {{decisionLabel}}",
    "computedDecision": "computed decision",
    "absence_justify": "Absences justified ({{records}} session(s))",
    "absence_justify_reject": "Justification rejected",
    "document_request_done": "Request handled: {{kindLabel}}",
    "document_request_rejected": "Request rejected: {{kindLabel}}",
    "payment_create": "Payment recorded: {{amountLabel}} ({{methodLabel}})",
    "payment_cancel": "Payment cancelled: {{amountLabel}}"
  },
  "newStudent": {
    "title": "New student",
    "subtitle": "The student ID and sign-in account are created automatically.",
    "enrollment": "Enrolment {{year}}",
    "submit": "Create record",
    "created": "Record {{matricule}} created.",
    "footerHint": "Enrolment {{year}} · the student ID is assigned on creation."
  },
  "curriculum": {
    "title": "Programmes",
    "listSubtitle": "LMD curricula per programme · versions and accreditation",
    "new": "New curriculum",
    "columns": {
      "program": "Programme",
      "name": "Curriculum",
      "version": "Version",
      "status": "Status",
      "credits": "Credits",
      "habilitation": "Accreditation",
      "enrollments": "Enrolled"
    },
    "status": {
      "draft": "Draft",
      "published": "Published"
    },
    "versionLabel": "v{{version}}",
    "subtitle": "LMD system · {{semesters}} semesters · {{credits}} ECTS credits",
    "habilitation": " · accreditation {{from}}-{{to}}",
    "addUnit": "Add a unit to S{{index}}",
    "publish": "Publish",
    "publishTip": "Fix the credit totals to publish",
    "publishedToast": "Curriculum published — used for new enrolments.",
    "newVersion": "Create a new version",
    "newVersionToast": "Version {{version}} created as a draft.",
    "openDraft": "Open the draft",
    "readOnly": "Published version, read-only. Create a new version to change it.",
    "warnItem": "Semester {{index}}: {{credits}} of {{target}} credits",
    "warnText": "Each semester must total exactly 30 ECTS credits before publishing. Adjust a course's credits or add a unit.",
    "okText": "Every semester totals 30 credits. The curriculum can be published.",
    "head": {
      "structure": "Structure",
      "nature": "Type",
      "credits": "Credits",
      "coef": "Coef.",
      "regime": "Assessment"
    },
    "root": "{{program}} curriculum · {{credits}} ECTS",
    "semester": "Semester {{index}}",
    "choice": "(elective)",
    "natures": {
      "F": "Core",
      "T": "Transversal",
      "O": "Elective"
    },
    "regimes": {
      "MIXTE": "Mixed",
      "CC": "Continuous",
      "EXAM": "Final exam"
    },
    "regimeHint": {
      "MIXTE": "Average = {{cc}} % continuous assessment + {{exam}} % final exam.",
      "CC": "Average computed from continuous assessment only; no final exam.",
      "EXAM": "Average = final exam only."
    },
    "inspector": {
      "empty": "Select a unit or a course to edit its settings.",
      "unitKind": "Teaching unit · {{code}}",
      "courseKind": "Course · {{code}}",
      "name": "Title",
      "nameAr": "Title (Arabic)",
      "code": "Code",
      "nature": "Unit type",
      "unitCredits": "Unit credits (sum of courses)",
      "unitCreditsOptional": "Unit credits (one elective course)",
      "unitHint": "The unit average is the coefficient-weighted average of its courses.",
      "eliminatory": "Eliminatory grade for this unit",
      "eliminatoryHint": "Empty: institution rule.",
      "credits": "ECTS credits",
      "coef": "Coefficient",
      "regime": "Assessment type",
      "hours": "Teaching hours",
      "cm": "Lectures",
      "td": "Tutorials",
      "tp": "Labs",
      "addCourse": "Add a course",
      "newCourse": "New course",
      "less": "Less",
      "more": "More"
    },
    "addUnitTitle": "New unit · semester {{index}}",
    "add": "Add",
    "unitAdded": "Unit “{{name}}” added to semester {{index}}.",
    "deleteTitle": "Delete “{{name}}”?",
    "deleteText": "The semester credits will be recalculated.",
    "deleted": "Deleted. Credits recalculated.",
    "newTitle": "New curriculum",
    "program": "Programme",
    "name": "Curriculum title",
    "from": "Accredited from",
    "to": "to",
    "createDraft": "Create the draft",
    "enrollmentsCount": "{{count}} enrolled",
    "errors": {
      "unitCode": "Expected code: 2–4 letters then 1–3 digits (e.g. UEF35).",
      "nameRequired": "Enter a title.",
      "duplicate": "This code already exists in the curriculum.",
      "draftExists": "A draft already exists for this programme.",
      "published": "This version is published: create a new version to change it.",
      "save": "Change refused. Check the value and try again."
    }
  },
  "reference": {
    "errors": {
      "programCode": "2 to 4 capital letters.",
      "groupName": "Group name: 1 to 3 characters (e.g. A)."
    }
  },
  "settings": {
    "navLabel": "Settings sections",
    "save": "Save changes",
    "saveStatus": {
      "saving": "Saving…",
      "saved": "Changes saved",
      "error": "Could not save"
    },
    "nav": {
      "etablissement": "Institution",
      "identite": "Visual identity",
      "annees": "Academic years",
      "roles": "Roles & permissions",
      "regles": "Grading rules",
      "structure": "Structure"
    },
    "errors": {
      "generic": "Change refused. Check the values and try again.",
      "version": "These settings were changed in the meantime. Reload the page.",
      "defaultLocale": "The default language must stay enabled.",
      "color": "Invalid colour.",
      "contrast": "Contrast is too low: choose a darker shade (minimum 4.5:1).",
      "thresholds": "The watch threshold must stay at or below the alert, and the alert at or below elimination.",
      "weekdays": "Choose at least one day.",
      "slots": "Slots must not overlap, and must end after they start.",
      "eliminatory": "The eliminatory grade must be below the pass mark.",
      "yearDates": "Dates must follow this order: start, end of S1, end of S2, end of year.",
      "yearLabel": "Expected label: YYYY-YYYY, and it must be unique.",
      "yearOrder": "The new year must start after the latest one.",
      "yearStatus": "This action is not allowed for the year’s current status.",
      "matriculePattern": "Invalid student ID format."
    },
    "establishment": {
      "name": "Legal name",
      "shortName": "Short name",
      "agrementNo": "Accreditation no.",
      "address": "Address",
      "phone": "Phone",
      "email": "Registrar e-mail",
      "locales": "Interface languages",
      "localesHint": "Click a language to enable or remove it. “Default” picks it among the enabled languages.",
      "default": "default",
      "makeDefault": "Default",
      "saved": "Institution saved."
    },
    "brand": {
      "subtitle": "The primary colour applies at once to the whole application, official documents and the student space.",
      "logo": "Logo",
      "replace": "Replace",
      "remove": "Remove",
      "logoHint": "PNG or JPEG, 1 MB maximum",
      "logoSaved": "Logo updated.",
      "logoType": "File refused: PNG or JPEG only.",
      "logoSize": "The file is larger than 1 MB.",
      "color": "Primary colour",
      "custom": "Custom colour",
      "swatches": {
        "indigo": "Indigo",
        "blue": "Institutional blue",
        "teal": "Teal",
        "green": "Green",
        "bordeaux": "Burgundy",
        "gold": "Gold (insufficient contrast)"
      },
      "contrastOk": "White text contrast: {{ratio}}:1 — meets WCAG AA.",
      "contrastFail": "White text contrast: {{ratio}}:1 — too low (minimum 4.5:1). Choose a darker shade.",
      "preview": "Live preview",
      "dashboard": "Dashboard",
      "newEnrollment": "New enrolment",
      "export": "Export",
      "tabInfo": "Information",
      "tabGrades": "Grades",
      "transcript": "TRANSCRIPT",
      "letterhead": "Official document header",
      "saved": "Colour saved."
    },
    "years": {
      "new": "New year",
      "empty": "No academic year.",
      "rentree": "Start {{date}}",
      "closedOn": "Closed on {{date}}",
      "untilS1": "S1 until {{date}}",
      "untilS2": "S2 until {{date}}",
      "activate": "Open",
      "archive": "Archive",
      "delete": "Delete",
      "deleteBlocked": "Not possible: enrolments already exist.",
      "activateTitle": "Open {{label}}?",
      "activateText": "It becomes the current year. The year that is current now will be closed.",
      "archiveTitle": "Archive {{label}}?",
      "archiveText": "An archived year stays readable and can no longer be edited.",
      "deleteTitle": "Delete {{label}}?",
      "deleteText": "The draft and any copied groups, fees or slots will be removed.",
      "activated": "Year opened.",
      "archived": "Year archived.",
      "deleted": "Draft deleted.",
      "created": "Year created · {{groups}} groups, {{fees}} fee schedules, {{slots}} slots.",
      "dialogTitle": "New academic year",
      "label": "Label",
      "startsOn": "Start",
      "s1EndsOn": "End of semester 1",
      "s2EndsOn": "End of semester 2",
      "endsOn": "End of year",
      "copyGroups": "Copy groups",
      "copyFees": "Copy fees",
      "copySlots": "Copy timetable slots",
      "helper": "The published curriculum stays in force: programmes are not tied to a year and are not copied. Groups and fees can be copied from the latest year (fee due dates move forward one year). Timetable slots are copied only if you ask for them.",
      "create": "Create the year"
    },
    "roles": {
      "subtitle": "Click a cell to grant or remove access.",
      "module": "Module",
      "accounts_one": "{{n}} account",
      "accounts_other": "{{n}} accounts",
      "locked": "Cannot be changed",
      "cycle": "Click to change",
      "saveFailed": "Permission was not changed.",
      "level": {
        "edit": "Edit",
        "read": "Read",
        "own": "Own",
        "none": "None"
      },
      "short": {
        "ADMIN_ECOLE": "Administration",
        "AGENT_SCOLARITE": "Registrar",
        "AGENT_FINANCE": "Finance",
        "ENSEIGNANT": "Teacher",
        "ETUDIANT": "Student",
        "CANDIDAT": "Applicant"
      },
      "cellLabel": "{{module}} — {{role}}: {{level}}",
      "accounts_zero": "{{n}} accounts"
    },
    "modules": {
      "dashboard": "Dashboard",
      "admissions": "Applications",
      "students": "Student records",
      "curriculum": "Curriculum",
      "timetable": "Timetable",
      "attendance": "Absences",
      "grades": "Grade entry",
      "deliberations": "Deliberations",
      "documents": "Transcripts & certificates",
      "finance": "Finance",
      "announcements": "Announcements",
      "settings": "Settings",
      "audit": "Audit log",
      "internships": "Internships"
    },
    "rules": {
      "title": "Grading & deliberation rules",
      "passMark": "Pass mark",
      "passMarkHint": "Out of 20, per semester",
      "eliminatory": "Eliminatory module grade",
      "eliminatoryHint": "Blocks compensation",
      "weights": "Weighting test / lab / exam",
      "weightsHint": "Mixed régime, in %",
      "weightsSum": "The three shares must add up to 100%.",
      "ds": "Test",
      "tp": "Lab",
      "exam": "Exam",
      "elimination": "Elimination threshold (absences)",
      "eliminationHint": "Unjustified absences per course. Empty = no elimination.",
      "alert": "Alert threshold (absences)",
      "alertHint": "Automatic notification",
      "watch": "Watch threshold",
      "watchHint": "Must stay at or below the alert threshold",
      "rounding": "Average rounding",
      "roundingHint": "At each level: rounded averages feed the next calculation. Final only: full precision, rounded for display.",
      "roundingMode": {
        "each_level": "At each level",
        "final": "Final only"
      },
      "compensation": "Compensation between modules of the same semester",
      "compensationHint": "Semester passed if the average is at least 10 and no module is eliminatory",
      "retake": "Keep the better mark at resit",
      "retakeHint": "Otherwise the resit mark replaces the original mark",
      "publish": "Publish results automatically",
      "publishHint": "As soon as the minutes are signed by the jury chair",
      "timetableTitle": "Timetable",
      "weekdays": "Working days",
      "weekdaysHint": "At least one day",
      "weekday": {
        "1": "Mon",
        "2": "Tue",
        "3": "Wed",
        "4": "Thu",
        "5": "Fri",
        "6": "Sat",
        "7": "Sun"
      },
      "slots": "Time slots",
      "slotsHint": "Start and end times, without overlaps",
      "slotStart": "Start",
      "slotEnd": "End",
      "addSlot": "Add a slot",
      "removeSlot": "Remove slot",
      "featuresTitle": "Upcoming features",
      "featuresHint": "These options do nothing until a provider is connected.",
      "feature": {
        "onlinePayment": "Online payment",
        "smsReminders": "SMS reminders",
        "whatsappReminders": "WhatsApp reminders",
        "sso": "Single sign-on (SSO)"
      },
      "documentsTitle": "Documents and student IDs",
      "signatoryName": "Signatory",
      "signatoryTitle": "Signatory title",
      "city": "City (“Done at”)",
      "matricule": "Student ID pattern",
      "matriculeHint": "{YY}{PROGRAM}{SEQ:4}",
      "saved": "Rules saved.",
      "eliminationBarsExam": "Absence exclusion: retake required",
      "eliminationBarsExamHint": "An excluded course is not passed at the main session and blocks compensation",
      "reviewDays": "Grade check requests",
      "reviewDaysHint": "Time given to students after the results of a session are published.",
      "reviewDaysValue_one": "{{count}} day",
      "reviewDaysValue_other": "{{count}} days",
      "reviewDaysOff": "Disabled"
    },
    "structure": {
      "programs": "Programmes",
      "groups": "Groups",
      "rooms": "Rooms",
      "addProgram": "New programme",
      "addGroup": "New group",
      "addRoom": "New room",
      "editRoom": "Edit room",
      "empty": "Nothing here yet.",
      "noYear": "Choose an academic year in the top bar.",
      "code": "Code",
      "name": "Name",
      "nameAr": "Name in Arabic",
      "cycle": "Cycle",
      "duration": "Duration (years)",
      "years": "{{n}} years",
      "capacity": "Capacity",
      "seats": "{{size}} / {{capacity}}",
      "level": "Level",
      "groupName": "Group name",
      "kind": "Type",
      "status": "Status",
      "active": "Active",
      "inactive": "Inactive",
      "create": "Create",
      "programCreated": "Programme created.",
      "groupCreated": "Group created.",
      "roomSaved": "Room saved.",
      "cycles": {
        "ingenieur": "Engineering",
        "licence": "Bachelor",
        "master": "Master"
      },
      "kinds": {
        "amphi": "Lecture hall",
        "salle": "Room",
        "labo": "Laboratory"
      }
    }
  },
  "grades": {
    "mySheets": "My grade sheets",
    "listSubtitle": "Grade sheets · {{year}}",
    "empty": "No grade sheet",
    "emptyText": "Sheets appear here once the exam sessions are open.",
    "notFound": "Grade sheet not found",
    "groupLabel": "{{level}} · Group {{group}}",
    "groupLong": "{{level}} Group {{group}}",
    "semester": "Semester {{n}}",
    "formula": "Average = {{weights}}",
    "session": {
      "principale": "Main session",
      "rattrapage": "Resit session"
    },
    "status": {
      "brouillon": "Draft",
      "transmis": "Submitted"
    },
    "kinds": {
      "DS": "Test",
      "TP": "Lab",
      "EXAM": "Exam",
      "RATTRAPAGE": "Resit"
    },
    "columns": {
      "course": "Course",
      "group": "Class",
      "semester": "Semester",
      "teacher": "Teacher",
      "progress": "Entry",
      "status": "Status",
      "matricule": "Student ID",
      "name": "Full name",
      "average": "Average"
    },
    "filters": {
      "level": "Level"
    },
    "savedAt": "Saved at {{time}}",
    "saveFailed": "Saving failed — retrying on next entry",
    "cellLabel": "{{kind}} — {{name}}",
    "absentTip": "Absent — counts as 0",
    "issues": {
      "invalid_one": "{{count}} invalid value to fix (in red) · {{empty}} missing mark(s). Locking is disabled until the sheet is complete.",
      "invalid_other": "{{count}} invalid values to fix (in red) · {{empty}} missing mark(s). Locking is disabled until the sheet is complete.",
      "empty_one": "{{count}} missing mark. Complete the sheet or import an Excel file.",
      "empty_other": "{{count}} missing marks. Complete the sheet or import an Excel file."
    },
    "lock": "Lock and submit",
    "lockedLabel": "Locked",
    "lockTip": "Fix invalid values and complete the sheet",
    "lockTitle": "Lock and submit?",
    "lockText_one": "The mark of {{count}} student will be sent to the board. You will need a correction request to change it.",
    "lockText_other": "The marks of {{count}} students will be sent to the board. You will need a correction request to change them.",
    "lockConfirm": "Lock",
    "lockedToast": "Marks locked and sent to the board.",
    "lockedBanner": "Marks locked and sent to the registrar on {{date}} at {{time}}. Any change now requires a correction request.",
    "unlock": "Unlock",
    "unlockedToast": "Sheet unlocked: the teacher can enter marks again.",
    "errors": {
      "format": "Not a number",
      "range": "Out of range (0 to 20)",
      "decimals": "Two decimals at most",
      "absentWithValue": "An absent mark cannot have a value",
      "reason": "Reason too short (5 characters minimum)",
      "lock": "Action failed, please retry.",
      "lockIncomplete": "The sheet is incomplete: fill every mark before locking.",
      "unlockPv": "The minutes of this session have been issued: the sheet can no longer be unlocked."
    },
    "stats": {
      "title": "Statistics",
      "average": "Class average",
      "max": "Highest",
      "min": "Lowest",
      "passRate": "Pass rate",
      "histogram": "Averages by 2-point band"
    },
    "shortcuts": {
      "title": "Keyboard shortcuts",
      "cell": "Next cell",
      "row": "Next row",
      "enter": "Enter",
      "absent": "Absent at the exam",
      "accepted": "Accepted values: 0 to 20, two decimals (comma or dot)."
    },
    "import": {
      "button": "Import Excel",
      "title": "Import from Excel",
      "pick": "Choose an .xlsx file",
      "hint": "Drop the file or click · columns Student ID, Test, Lab, Exam",
      "detected_one": "{{count}} row found",
      "detected_other": "{{count}} rows found",
      "recognized_one": "{{count}} student ID recognised",
      "recognized_other": "{{count}} student IDs recognised",
      "unknown_one": "{{count}} unknown student ID: {{list}}",
      "unknown_other": "{{count}} unknown student IDs: {{list}}",
      "invalid_one": "{{count}} invalid value ignored: {{list}}",
      "invalid_other": "{{count}} invalid values ignored: {{list}}",
      "cell": "row {{row}}, {{column}} = “{{value}}”",
      "fillable_one": "{{count}} empty cell will be filled",
      "fillable_other": "{{count}} empty cells will be filled",
      "noOverwrite_one": "Existing marks are never overwritten ({{count}} ignored).",
      "noOverwrite_other": "Existing marks are never overwritten ({{count}} ignored).",
      "template": "Download template",
      "apply": "Import",
      "done_one": "Import done: {{count}} mark filled.",
      "done_other": "Import done: {{count}} marks filled.",
      "errors": {
        "file": "Unreadable file: use the .xlsx template.",
        "columns": "Expected columns: Student ID and at least Test, Lab or Exam.",
        "size": "File too large (1 MB max).",
        "locked": "The sheet is locked: import is no longer possible."
      },
      "analysing": "Analysing the file…"
    },
    "corrections": {
      "request": "Request a correction",
      "title": "Correction request",
      "text": "The sheet is locked. The change is applied once approved by the registrar and kept in the history.",
      "assessment": "Assessment",
      "current": "Current mark",
      "newValue": "New mark",
      "reason": "Reason",
      "reasonHint": "E.g. transcription error, paper re-marked…",
      "send": "Send request",
      "sent": "Correction request sent to the registrar.",
      "pendingExists": "A request is already pending for this mark.",
      "error": "Action failed, please retry.",
      "pendingTitle_one": "{{count}} pending correction request",
      "pendingTitle_other": "{{count}} pending correction requests",
      "approve": "Approve",
      "reject": "Reject",
      "approved": "Correction approved and applied.",
      "rejected": "Correction rejected."
    },
    "eliminated": "Excluded",
    "eliminatedHint": "Absence threshold exceeded: course not passed at the main session, retake required",
    "savedOn": "Saved on {{date}} at {{time}}"
  },
  "deliberation": {
    "title": "Board {{level}} · Semester {{n}}",
    "listSubtitle": "Examination boards · {{year}}",
    "empty": "No board for this year",
    "notFound": "Board not found",
    "sessionLabel": "Session",
    "session": {
      "principale": "Main session",
      "rattrapage": "Resit"
    },
    "sessionLong": {
      "principale": "Main session",
      "rattrapage": "Resit session"
    },
    "ueCount_one": "{{count}} unit",
    "ueCount_other": "{{count}} units",
    "credits_one": "{{count}} credit",
    "credits_other": "{{count}} credits",
    "cr_one": "{{count}} cr.",
    "cr_other": "{{count}} cr.",
    "rulesLine": "Semester compensation if average ≥ {{min}} and no unit < {{elim}}",
    "rulesLineNoElim": "Semester compensation if average ≥ {{min}}",
    "rulesNoComp": "No semester compensation",
    "pv": {
      "open": "Minutes not issued",
      "generated": "Minutes issued",
      "toValidate": "Minutes to validate",
      "waitingSheets": "Grades in progress",
      "waitingPrincipale": "After the main session"
    },
    "generatePv": "Issue minutes",
    "downloadPv": "Download minutes",
    "pvRendering": "Minutes being generated…",
    "pvFailed": "Minutes generation failed",
    "blockedTip": "Every sheet must be locked and every result complete",
    "pendingSheets_one": "{{count}} grade sheet not locked",
    "pendingSheets_other": "{{count}} grade sheets not locked",
    "kpi": {
      "students": "Students",
      "admitted": "Passed",
      "rattrapage": "Resit",
      "ajournes": "Failed",
      "passRate": "Pass rate"
    },
    "filters": {
      "admitted": "Passed",
      "rattrapage": "Resit",
      "ajournes": "Failed"
    },
    "legend": {
      "compensated": "Compensated unit",
      "notAcquired": "Unit not passed"
    },
    "columns": {
      "jury": "Board",
      "sheets": "Locked sheets",
      "principale": "Main session",
      "rattrapage": "Resit",
      "student": "Student",
      "average": "Average",
      "credits": "Credits",
      "compensation": "Compensation",
      "decision": "Decision"
    },
    "comp": {
      "yes_one": "Yes · {{count}} unit",
      "yes_other": "Yes · {{count}} units",
      "eliminatory": "No · mark < {{grade}}",
      "average": "No · average < {{min}}",
      "disabled": "Not applicable"
    },
    "incomplete": "Missing marks",
    "incompleteShort": "Incomplete",
    "noStudents": "No student for this session",
    "decision": {
      "ADMIS": "Passed",
      "ADMIS_COMPENSATION": "Passed by compensation",
      "RATTRAPAGE": "Resit",
      "AJOURNE": "Failed"
    },
    "studentsCount_one": "{{count}} student",
    "studentsCount_other": "{{count}} students",
    "pvToast": "{{file}} issued and sent to the board members for signature.",
    "pvDialog": {
      "title": "Issue the minutes",
      "stats": "Include per-unit statistics",
      "signatures": "Electronic signature by board members",
      "publish": "Publish results in the student space",
      "members": "Board members",
      "president": "{{name}} (chair)",
      "freeze": "Decisions will be frozen: no mark or decision of this session can be changed afterwards.",
      "generate": "Issue",
      "generating": "Issuing…"
    },
    "override": {
      "button": "Change decision",
      "title": "Board decision",
      "computed": "computed decision: {{decision}}",
      "decision": "Final decision",
      "none": "Computed decision (no change)",
      "reason": "Reason",
      "reasonHint": "Required, recorded in the audit log.",
      "saved": "Board decision saved.",
      "badge": "Decision changed by the board",
      "tip": "Decision changed by the board: {{reason}}"
    },
    "rattrapage": {
      "waitTitle": "Main session not deliberated",
      "waitText": "Issue the main session minutes first: they set the list of students called to the resit.",
      "prepareTitle": "Resit sheets to prepare",
      "prepareText_one": "{{count}} student called: create the grade sheets of the courses to retake.",
      "prepareText_other": "{{count}} students called: create the grade sheets of the courses to retake.",
      "prepare": "Prepare sheets",
      "prepared": "{{sheets}} resit sheet(s) created for {{students}} student(s)."
    },
    "errors": {
      "blocked": "Cannot issue: some sheets are not locked or some results are incomplete.",
      "generic": "Action failed, please retry.",
      "reason": "Reason too short (5 characters minimum)"
    }
  },
  "documents": {
    "listSubtitle": "Transcripts, certificates and minutes issued, verifiable by QR code",
    "newTranscript": "New transcript",
    "search": "Name, student ID or code",
    "count_one": "{{n}} document",
    "count_other": "{{n}} documents",
    "empty": "No document issued",
    "emptyText": "Transcripts and certificates issued from a student record appear here.",
    "emptyFiltered": "No document matches the filters",
    "code": "Verification code",
    "download": "Download",
    "downloadNamed": "Download {{file}}",
    "downloaded": "{{file}} downloaded (electronically signed).",
    "generating": "Generating…",
    "sent": "Document e-mailed and published in the student space.",
    "verifyOnline": "Verify online",
    "certificateDone": "Enrolment certificate {{year}} issued.",
    "recordEmpty": "No document issued for this student",
    "recordEmptyText": "Issue an enrolment certificate or a transcript from the record header.",
    "types": {
      "RELEVE": "Transcript",
      "ATTESTATION_INSCRIPTION": "Enrolment certificate",
      "PV": "Board minutes",
      "RECU": "Payment receipt",
      "CONVENTION_STAGE": "Internship agreement"
    },
    "status": {
      "pending": "In progress",
      "ready": "Valid",
      "failed": "Failed",
      "revoked": "Revoked"
    },
    "columns": {
      "type": "Document",
      "student": "Student",
      "issuedOn": "Issued on",
      "status": "Status"
    },
    "meta": {
      "issued": "Issued on {{date}}",
      "revoked": "Revoked on {{date}}"
    },
    "pick": {
      "label": "Student (name or ID)",
      "hint": "Type at least 2 characters",
      "none": "No student found"
    },
    "revoke": {
      "button": "Revoke",
      "named": "Revoke document {{code}}",
      "title": "Revoke this document?",
      "text": "The code stays known on the verification page but shows as revoked. This is final and audited.",
      "reason": "Reason for revocation",
      "reasonHint": "Required (5 characters minimum), recorded in the audit log.",
      "confirm": "Revoke",
      "done": "Document revoked."
    },
    "transcript": {
      "title": "Transcript",
      "subtitle": "A4 preview · official electronically signed document",
      "send": "Send to the student",
      "send_F": "Send to the student",
      "send_M": "Send to the student",
      "print": "Print",
      "download": "Download PDF",
      "options": "Options",
      "semester": "Semester",
      "semesterN": "Semester {{n}}",
      "semesterOption": "Semester {{n}} · {{level}} · {{year}}",
      "qr": "Verification QR code",
      "courses": "Show courses",
      "notIssued": "Not issued — the code is assigned on first download or send.",
      "previewTitle": "Transcript preview",
      "emptyTitle": "No deliberated semester",
      "emptyText": "An official transcript can only be issued once the board minutes are generated."
    },
    "errors": {
      "generic": "Action failed, please retry.",
      "notDeliberated": "The board has not deliberated this semester yet.",
      "noEmail": "No e-mail address in the student record.",
      "withdrawn": "Withdrawn enrolment: no certificate can be issued.",
      "reason": "Reason too short (5 characters minimum)"
    },
    "requests": {
      "title_one": "{{count}} student request",
      "title_other": "{{count}} student requests",
      "open": "Open record",
      "done": "Mark as done",
      "reject": "Reject",
      "doneTitle": "Close the request as done?",
      "rejectTitle": "Reject the request?",
      "answer": "Message to the student (optional)",
      "answerDone": "E.g. collect it at the registrar's desk.",
      "answerRejected": "E.g. not available for your level.",
      "doneToast": "Request handled. The student was notified.",
      "rejectedToast": "Request rejected. The student was notified.",
      "failed": "Action failed. Reload the page."
    }
  },
  "verify": {
    "title": "Verify a document",
    "intro": "Enter the code printed under the QR code of a transcript, certificate or diploma issued by the institution.",
    "code": "Verification code",
    "submit": "Verify",
    "valid": "Authentic document",
    "validText": "Issued by the institution and not revoked to date.",
    "revoked": "Revoked document",
    "revokedText": "This document was cancelled by the institution on {{date}} and is no longer valid.",
    "notFound": "No matching document",
    "notFoundText": "Check the code you typed. If the problem persists, contact the registrar's office at {{phone}}.",
    "notFoundTextNoPhone": "Check the code you typed. If the problem persists, contact the registrar's office.",
    "limited": "Too many checks in a short time. Try again in a minute.",
    "notice": "The information shown must match the document presented exactly. For privacy, the name is partially masked.",
    "issuedBy": "{{date}} · signed by {{name}}",
    "fields": {
      "type": "Type",
      "holder": "Holder",
      "matricule": "Student ID",
      "program": "Programme",
      "period": "Period",
      "issuedOn": "Issued on",
      "receipt": "Receipt no.",
      "amount": "Amount"
    }
  },
  "admissions": {
    "title": "Pre-registration {{year}}",
    "stepOf": "Step {{n}} of {{total}} · {{name}}",
    "progress": "Form progress",
    "draft": "Draft",
    "draftError": "Offline — retrying",
    "continue": "Continue",
    "submit": "Submit my file",
    "sending": "Sending…",
    "closedTitle": "Pre-registration closed",
    "closedText": "Online pre-registration at {{name}} is not open at the moment.",
    "steps": {
      "program": "Programme",
      "identity": "Identity",
      "school": "Schooling",
      "pieces": "Documents",
      "recap": "Summary",
      "programTitle": "Choose your programme",
      "identityTitle": "Your identity",
      "schoolTitle": "School background",
      "piecesTitle": "Supporting documents"
    },
    "programDesc_one": "{{cycle}} · {{count}} year",
    "programDesc_other": "{{cycle}} · {{count}} years",
    "programMeta": "Capacity {{capacity}} · {{sections}}",
    "fields": {
      "lastName": "Last name",
      "firstName": "First name",
      "cin": "ID card number",
      "birthDate": "Date of birth",
      "email": "E-mail",
      "phone": "Phone",
      "bacSection": "Baccalaureate stream",
      "bacSession": "Session",
      "bacAverage": "Average /20",
      "highSchool": "High school"
    },
    "bacSession": {
      "principale": "Main {{year}}",
      "controle": "Resit {{year}}"
    },
    "sections": {
      "0": "Mathematics",
      "1": "Experimental sciences",
      "2": "Technical sciences",
      "3": "Computer science",
      "4": "Economics & management",
      "5": "Humanities",
      "6": "Sport"
    },
    "sectionsShort": {
      "0": "Maths",
      "1": "Exp. sc.",
      "2": "Tech. sc.",
      "3": "CS",
      "4": "Econ.",
      "5": "Humanities",
      "6": "Sport"
    },
    "sectionDirect": "The {{section}} stream gives direct access to the chosen programme.",
    "sectionCommission": "The {{section}} stream is not a priority for this programme: the committee will review your file.",
    "pieces": {
      "hint": "PDF, JPG or PNG · 5 MB max per file. You can take photos of your documents.",
      "kinds": {
        "cin": "ID card copy (both sides)",
        "bac_transcript": "Baccalaureate transcript",
        "bac_certificate": "Pass certificate",
        "photo": "ID photo",
        "fee_receipt": "Application fee receipt"
      },
      "none": "Not uploaded",
      "uploading": "Uploading…",
      "sent": "Uploaded · {{size}}",
      "verified": "Checked by the registrar",
      "rejected": "Upload again: {{reason}}",
      "tooLargeSize": "File too large ({{size}}) — 5 MB max.",
      "add": "Add",
      "remove": "Remove",
      "retry": "Retry",
      "replace": "Replace",
      "errors": {
        "too_large": "File too large — 5 MB max.",
        "type": "Format not accepted (PDF, JPG or PNG).",
        "network": "Connection lost.",
        "other": "Upload failed, please retry."
      },
      "open": "Open: {{name}}",
      "openFailed": "Could not open the document. Try again in a moment."
    },
    "size": {
      "kb": "{{n}} KB",
      "mb": "{{n}} MB"
    },
    "recap": {
      "choice": "Choice",
      "level": "Level",
      "firstYear": "1st year · {{year}}",
      "name": "Name",
      "schoolAndPieces": "Schooling & documents",
      "bac": "Bac",
      "pieces": "Documents",
      "piecesCount": "{{n}} / {{total}} uploaded"
    },
    "consent": "I certify that the information provided is accurate and I accept the institution's rules.",
    "fee": "Application fee",
    "feeHint": "Pay by bank transfer or at the desk; attach the receipt to your documents.",
    "sent": {
      "title": "File submitted",
      "text": "A confirmation e-mail was sent to {{email}}.",
      "tracking": "Tracking number",
      "code": "Access code",
      "keep": "Keep both: they let you follow your file.",
      "follow": "Follow my file"
    },
    "track": {
      "title": "Follow your file",
      "intro": "Enter your tracking number and the access code received by e-mail.",
      "tracking": "Tracking number",
      "code": "Access code",
      "codeHint": "8 characters, sent with the submission confirmation.",
      "submit": "View",
      "notFound": "File not found",
      "notFoundText": "Check the tracking number and the access code.",
      "follow": "Your file",
      "filed": "File submitted",
      "feePaid": "Application fee paid",
      "feeCheck": "Application fee",
      "feeCheckText": "Receipt being checked",
      "review": "Committee review",
      "reviewText_one": "Answer within {{count}} working day",
      "reviewText_other": "Answer within {{count}} working days",
      "interview": "Admission interview",
      "decision": "Decision & enrolment",
      "decisionText": "You will be notified by e-mail",
      "accepted": "Application accepted",
      "acceptedText": "The registrar's office will contact you to enrol.",
      "refused": "Application not accepted",
      "refusedText": "You can contact the registrar's office.",
      "missing_one": "{{count}} document to upload or replace.",
      "missing_other": "{{count}} documents to upload or replace.",
      "trackingFormat": "Expected format: PRE-2026-0412.",
      "codeFormat": "The access code has 8 characters.",
      "showCode": "Show the code",
      "hideCode": "Hide the code"
    },
    "candidate": {
      "empty": "No pre-registration file",
      "emptyText": "Apply online in a few minutes.",
      "apply": "Start my pre-registration",
      "uploadHint": "To upload a document, use the tracker with your number and access code."
    },
    "status": {
      "draft": "Draft",
      "submitted": "New",
      "review": "Under review",
      "interview": "Interview",
      "accepted": "Accepted",
      "refused": "Refused"
    },
    "tabs": {
      "all": "All",
      "submitted": "New",
      "review": "Under review",
      "interview": "Interview",
      "accepted": "Accepted",
      "refused": "Refused"
    },
    "columns": {
      "tracking": "File no.",
      "candidate": "Candidate",
      "program": "Programme",
      "bac": "Bac · average",
      "filedOn": "Filed on",
      "pieces": "Documents",
      "status": "Status"
    },
    "staff": {
      "title": "Applications {{year}}",
      "subtitle": "Review the files submitted online and decide on admission.",
      "publicForm": "Open the public form",
      "search": "Name, ID or file number",
      "allPrograms": "All programmes",
      "since": "Filed since",
      "selection_one": "{{count}} application selected",
      "selection_other": "{{count}} applications selected",
      "empty": "No application for these filters",
      "emptyText": "Change the criteria or reset the search to show all applications.",
      "resetFilters": "Reset filters",
      "noneYet": "No application received yet",
      "noneYetText": "Applications filed through the public pre-registration form will appear here."
    },
    "actions": {
      "accept": "Accept",
      "interview": "Invite to an interview",
      "convoke": "Invite",
      "refuse": "Refuse",
      "reopen": "Reopen file"
    },
    "bulk": {
      "title": {
        "accept_one": "Accept this application?",
        "accept_other": "Accept {{count}} applications?",
        "interview_one": "Invite to an interview",
        "interview_other": "Invite {{count}} candidates to an interview",
        "refuse_one": "Refuse this application?",
        "refuse_other": "Refuse {{count}} applications?",
        "review_one": "Reopen this file?",
        "review_other": "Reopen {{count}} files?"
      },
      "text": {
        "accept": "Candidates will be notified by e-mail. You can then create their student records.",
        "interview": "An invitation is e-mailed with the date and time.",
        "refuse": "Candidates will be notified by e-mail. You can reopen a file from its history.",
        "review": "The file goes back to “Under review”; the candidate is not notified."
      },
      "confirm": {
        "accept": "Accept",
        "interview": "Send invitation",
        "refuse": "Refuse",
        "review": "Reopen"
      },
      "done": {
        "accept_one": "{{count}} application accepted — admission e-mail sent.",
        "accept_other": "{{count}} applications accepted — admission e-mails sent.",
        "interview_one": "{{count}} invitation sent for {{date}}.",
        "interview_other": "{{count}} invitations sent for {{date}}.",
        "refuse_one": "{{count}} application refused.",
        "refuse_other": "{{count}} applications refused.",
        "review_one": "{{count}} file reopened.",
        "review_other": "{{count}} files reopened."
      },
      "skipped_one": "{{count}} file skipped (status not compatible).",
      "skipped_other": "{{count}} files skipped (status not compatible).",
      "reason": "Reason given to the candidate (optional)",
      "reasonPlaceholder": "E.g. capacity reached for this programme.",
      "when": "Interview date and time"
    },
    "sheet": {
      "label": "Application details",
      "program": "Programme",
      "firstYear": "1st year · intake {{year}}",
      "interviewOn": "Interview on {{date}} at {{time}}",
      "refusedReason": "Reason: {{reason}}",
      "bac": "Baccalaureate",
      "bacAverage": "Bac average",
      "pieceMeta": "{{size}} · uploaded on {{date}}",
      "preview": "Preview",
      "previewNamed": "Preview: {{piece}}",
      "verify": "Validate document",
      "verifyNamed": "Validate: {{piece}}",
      "reject": "Reject",
      "rejectNamed": "Reject: {{piece}}",
      "rejectTitle": "Reject “{{piece}}”?",
      "rejectText": "The candidate is e-mailed and can upload a new document from the tracker.",
      "rejectReason": "Reason (sent to the candidate)",
      "rejectPlaceholder": "E.g. unreadable, back side missing.",
      "pieceVerified": "Document validated.",
      "pieceRejected": "Document rejected — the candidate was notified.",
      "history": "History",
      "convert": "Create the student record",
      "converted": "Student record created (ID {{matricule}}).",
      "openRecord": "Open the student record"
    },
    "pieceStatus": {
      "missing": "Missing",
      "uploaded": "To check",
      "verified": "Checked",
      "rejected": "Rejected"
    },
    "mentions": {
      "tres_bien": "Very good",
      "bien": "Good",
      "assez_bien": "Fairly good",
      "passable": "Pass"
    },
    "history": {
      "submit": "File submitted online",
      "status": "Status: {{status}}",
      "piece_verify": "Document validated: {{piece}}",
      "piece_reject": "Document rejected: {{piece}} — {{reason}}",
      "piece_upload": "Document uploaded again: {{piece}}",
      "convert": "Student record created ({{matricule}})"
    },
    "overview": {
      "title": "Pre-registration {{year}}",
      "subtitle": "Online pre-registration campaign: public link, files and intake capacity.",
      "open": "Open",
      "closed": "Closed",
      "copy": "Copy the public link",
      "copied": "Link copied.",
      "filed": "Files submitted",
      "toReview": "To review",
      "drafts": "Drafts in progress",
      "draftsNote": "Forms started, not submitted",
      "intake": "Intake by programme",
      "intakeOf": "Admitted in {{name}}",
      "intakeLine": "{{accepted}} admitted / {{capacity}} places · {{filed}} files",
      "publicLink": "Public form link"
    },
    "errors": {
      "required": "Required field.",
      "cin": "The ID number must have 8 digits.",
      "email": "Invalid e-mail address.",
      "phone": "Invalid phone number.",
      "birthDate": "Date of birth is required.",
      "average": "Average between 0 and 20.",
      "program": "Choose a programme.",
      "tracking": "Invalid tracking number (e.g. PRE-2026-0412).",
      "interviewAt": "Set the interview date.",
      "reason": "Reason too short.",
      "consent": "Tick the box to confirm.",
      "missingPieces": "Upload every required document.",
      "duplicate": "A file already exists for this ID this year.",
      "submit": "Submission failed, please retry.",
      "action": "Action failed, please retry."
    },
    "listSeparator": ", "
  },
  "finance": {
    "title": "Tuition fees",
    "subtitle_one": "{{year}} · Tuition fees: {{total}} – {{count}} instalment",
    "subtitle_other": "{{year}} · Tuition fees: {{total}} – {{count}} instalments",
    "tabs": {
      "schedules": "Schedules",
      "unpaid": "Unpaid",
      "schedulesLong": "Student schedule",
      "unpaidLong": "Unpaid & reminders"
    },
    "pickStudent": "Search a student (name, ID, national ID)",
    "guardian": "guardian: {{name}}, {{phone}}",
    "openRecord": "Open record",
    "otherStudent": "Other student",
    "chequeNo": "no. {{n}}",
    "status": {
      "paid": "Paid",
      "late": "Unpaid",
      "todo": "Upcoming",
      "pending": "Cheque pending"
    },
    "paymentStatus": {
      "cleared": "Cleared",
      "pending": "Cheque pending",
      "rejected": "Cheque rejected",
      "cancelled": "Cancelled"
    },
    "methods": {
      "cash": "Cash",
      "cheque": "Cheque",
      "transfer": "Transfer",
      "online": "Online"
    },
    "channels": {
      "email": "E-mail",
      "sms": "SMS",
      "whatsapp": "WhatsApp"
    },
    "account": {
      "total": "Total {{year}}",
      "paid": "Paid",
      "remaining": "Balance due",
      "schedule": "Payment schedule",
      "paidPct": "{{pct}} % paid",
      "columns": {
        "installment": "Instalment",
        "dueOn": "Due date",
        "amount": "Amount",
        "status": "Status",
        "detail": "Details",
        "actions": "Actions"
      },
      "lateBy_one": "{{count}} day late",
      "lateBy_other": "{{count}} days late",
      "partial": "{{paid}} paid",
      "pendingInfo": "{{mode}} · clearing in progress",
      "noInstallments": "No schedule for this year",
      "notEnrolled": "Not enrolled this year",
      "canGenerateText": "The year’s fee scale has not been applied to this enrolment yet.",
      "noScheduleText": "No fee scale is defined for this programme and year.",
      "generate": "Generate the schedule"
    },
    "actions": {
      "collect": "Collect",
      "collectOf": "Collect · {{label}}",
      "receipt": "Receipt",
      "cancel": "Cancel payment",
      "cancelOf": "Cancel the payment of {{label}}",
      "clear": "Cheque cleared",
      "reject": "Rejected"
    },
    "pay": {
      "title": "Collect · {{label}}",
      "due": "due {{due}}",
      "amount": "Amount (TND)",
      "mode": "Payment method",
      "invalidAmount": "Enter a valid amount.",
      "overDue": "The amount exceeds the balance due ({{due}}).",
      "chequeNumber": "Cheque no.",
      "bank": "Bank",
      "reference": "Reference",
      "valueDate": "Value date",
      "cashBy": "Received by {{name}} · main cash desk · {{date}}",
      "chequeHint": "The cheque stays “pending” until it clears; the receipt is issued then.",
      "submit": "Record payment"
    },
    "receipt": {
      "title": "Payment recorded",
      "number": "Receipt",
      "student": "Student",
      "installment": "Instalment",
      "mode": "Method",
      "date": "Date",
      "amount": "Amount",
      "print": "Print",
      "send": "Send by e-mail"
    },
    "cancel": {
      "title": "Cancel this payment?",
      "text": "The payment of {{amount}} ({{label}}) will be cancelled and its receipt revoked; the instalment goes back to “Unpaid” if it is due. This is recorded in the history.",
      "confirm": "Cancel payment",
      "keep": "Keep"
    },
    "toast": {
      "cleared": "{{label}}: cheque cleared.",
      "rejected": "{{label}}: cheque rejected — instalment unpaid again.",
      "cancelled": "Payment of {{label}} cancelled.",
      "chequePending": "Cheque recorded for {{label}} — pending clearing.",
      "receiptSent": "Receipt sent by e-mail."
    },
    "errors": {
      "generic": "The operation failed. Try again.",
      "receipt": "The receipt could not be generated. Try again.",
      "noEmail": "The student has no e-mail address.",
      "trancheOrder": "Due dates must follow the instalment order.",
      "chequeNumber": "Enter the cheque number.",
      "bank": "Choose the bank.",
      "reference": "Enter the transfer reference."
    },
    "journal": {
      "title": "Latest payments",
      "pendingCheques": "Pending cheques",
      "date": "Date",
      "student": "Student",
      "installment": "Instalment",
      "mode": "Method",
      "amount": "Amount",
      "status": "Status",
      "receipt": "Receipt",
      "empty": "No payments",
      "emptyText": "Payments of the year will appear here."
    },
    "schedule": {
      "open": "Fee scale",
      "title": "Fee scale · {{year}}",
      "text": "Instalments applied to the year’s new enrolments. Existing schedules are not changed.",
      "label": "Label",
      "note": "Note",
      "dueOn": "Due date",
      "amount": "Amount (TND)",
      "add": "Add an instalment",
      "remove": "Remove instalment {{label}}",
      "total": "Total:",
      "trancheN": "Instalment {{n}}",
      "saved": "Fee scale saved.",
      "missing_one": "{{count}} enrolment has no schedule yet.",
      "missing_other": "{{count}} enrolments have no schedule yet.",
      "apply": "Apply the fee scale",
      "applied_one": "{{count}} schedule created.",
      "applied_other": "{{count}} schedules created."
    },
    "unpaid": {
      "kpi": {
        "amount": "Unpaid amount",
        "students": "Students concerned",
        "avgLate": "Average delay",
        "recovered": "Collected this month"
      },
      "columns": {
        "student": "Student",
        "program": "Programme",
        "installment": "Instalment",
        "amount": "Amount",
        "late": "Delay",
        "lastReminder": "Last reminder",
        "status": "Status"
      },
      "days": "{{n}} d",
      "minDays": "Over {{n}} d",
      "reminded": "Reminded",
      "search": "Search a student or ID",
      "selected_one": "{{count}} selected",
      "selected_other": "{{count}} selected",
      "remind": "Send a reminder",
      "empty": "No unpaid fees",
      "emptyText": "All past instalments are paid.",
      "emptyFiltered": "No results",
      "emptyFilteredText": "No unpaid instalment matches these filters.",
      "shown_one": "{{count}} unpaid shown of {{total}}",
      "shown_other": "{{count}} unpaid shown of {{total}}"
    },
    "remind": {
      "title_one": "Send a reminder · {{count}} recipient",
      "title_other": "Send a reminder · {{count}} recipients",
      "channels": "Channels",
      "preview": "Preview for {{name}}",
      "body": "Hello {{name}}, this is a reminder that {{installment}} of the tuition fees (amount due: {{amount}}) was due on {{dueOn}}. Please settle it with the finance office. — {{institution}}",
      "note": "Additional message (optional)",
      "noteHint": "Added to each student’s reminder.",
      "noEmail_one": "{{count}} student has no e-mail and will not receive it.",
      "noEmail_other": "{{count}} students have no e-mail and will not receive it.",
      "send": "Send",
      "sent_one": "{{count}} reminder sent.",
      "sent_other": "{{count}} reminders sent.",
      "sentSkipped_one": "{{count}} reminder sent ({{skipped}} without e-mail).",
      "sentSkipped_other": "{{count}} reminders sent ({{skipped}} without e-mail)."
    }
  },
  "attendance": {
    "title": "Absence monitoring",
    "subtitle": "Exclusion threshold: {{pct}} of unexcused absences over a course’s hours.",
    "subtitleNoElim": "No exclusion; alert at {{alert}} of unexcused absences over a course’s hours.",
    "rollCallLink": "Teacher roll call (mobile)",
    "notifyAll": "Notify students on alert",
    "listTitle": "Students near the threshold",
    "thresholdMark": "Threshold {{pct}}",
    "kpi": {
      "hours": "Absence hours (week {{week}})",
      "justified": "incl. {{hours}} excused",
      "rate": "Absence rate",
      "delta": "{{delta}} pt vs week {{week}}",
      "noPrevious": "no sessions the previous week",
      "alert": "On alert (≥ {{pct}})",
      "alertNote": "notification recommended",
      "elim": "Excluded (≥ {{pct}})",
      "elimNote": "barred from the course exam"
    },
    "filters": {
      "all": "All",
      "elim": "Excluded",
      "alert": "Alert",
      "watch": "Watched"
    },
    "levels": {
      "elim": "Excluded",
      "alert": "Alert",
      "watch": "Watched"
    },
    "columns": {
      "student": "Student",
      "group": "Group",
      "course": "Course",
      "rate": "Unexcused absences / threshold",
      "hours": "Hours",
      "status": "Status"
    },
    "actions": {
      "justify": "Excuse",
      "notify": "Notify",
      "notified": "Notified"
    },
    "empty": "No student in this category",
    "emptyText": "Absence rates stay below the thresholds.",
    "kinds": {
      "CM": "Lecture",
      "TD": "Tutorial",
      "TP": "Lab"
    },
    "reasons": {
      "medical": "Medical certificate",
      "administrative": "Official summons",
      "bereavement": "Bereavement",
      "other": "Other (specify)"
    },
    "justify": {
      "title": "Excuse an absence",
      "sessions": "Absences covered",
      "none": "No unexcused absence for this course.",
      "reason": "Reason",
      "note": "Details",
      "file": "Attach the document",
      "fileHint": "PDF, JPG or PNG · 5 MB max · optional",
      "tooLarge": "The file exceeds 5 MB.",
      "submit": "Validate the excuse",
      "done": "Excuse validated: {{hours}} removed for {{name}}."
    },
    "toast": {
      "notifiedOne": "{{name}} notified by e-mail.",
      "notified_one": "{{count}} student notified.",
      "notified_other": "{{count}} students notified."
    },
    "errors": {
      "generic": "The operation failed. Try again.",
      "endBeforeStart": "The end must be after the start.",
      "tooLong": "A session lasts at most 6 h."
    },
    "record": {
      "absent": "Absence hours",
      "justified": "incl. excused",
      "late": "Late arrivals",
      "byCourse": "By course",
      "sessions": "Missed sessions",
      "justifications": "Excuses",
      "columns": {
        "course": "Course",
        "hours": "Unexcused / hours",
        "rate": "Rate",
        "status": "Status"
      },
      "absentMark": "Absent · {{hours}}",
      "justifiedMark": "Excused · {{hours}}",
      "empty": "No absences",
      "emptyText": "No absence or late arrival in {{year}}."
    },
    "pending": {
      "title_one": "{{count}} justification to review",
      "title_other": "{{count}} justifications to review",
      "meta": "{{hours}} · sent on {{date}}",
      "view": "View document",
      "approve": "Approve",
      "reject": "Reject",
      "rejectTitle": "Reject {{name}}'s justification?",
      "reason": "Reason shown to the student (optional)",
      "approved": "Justification approved. The student was notified.",
      "rejected": "Justification rejected. The student was notified.",
      "failed": "Action failed. Reload the page."
    }
  },
  "rollCall": {
    "homeTitle": "Take attendance",
    "homeSubtitle": "Your sessions today and those still without a roll call.",
    "today": "Today",
    "noToday": "No session today",
    "pending": "Roll call to do",
    "pendingHint": "Past sessions without a recorded roll call.",
    "recent": "Latest roll calls",
    "groupLine": "{{level}} Group {{group}}",
    "doneChip": "Done · {{present}}/{{total}}",
    "todoChip": "To do",
    "newSession": "Extra session",
    "newSessionHint": "For a session outside the timetable (make-up, moved session).",
    "course": "Course and group",
    "kind": "Type",
    "date": "Date",
    "start": "Start",
    "duration": "Duration",
    "minutes": "{{n}} min",
    "room": "Room",
    "open": "Open roll call",
    "title": "Roll call · {{level}} Group {{group}}",
    "counters": {
      "present": "Present",
      "absent": "Absent",
      "late": "Late"
    },
    "marks": {
      "present": "Present",
      "absent": "Absent",
      "late": "Late"
    },
    "tapHint": "Tap a student to change their status",
    "allPresent": "All present",
    "rowLabel": "{{name}}: {{mark}}. Tap to change.",
    "validate_one": "Submit roll call · {{count}} student",
    "validate_other": "Submit roll call · {{count}} students",
    "confirmTitle": "Submit the roll call?",
    "confirmText": "Absent students will be notified; they have {{hours}} h to hand in a justification.",
    "confirm": "Confirm",
    "backToRoster": "Back to the list",
    "summary": "{{present}}, {{absent}}, {{late}}.",
    "presentN_one": "{{count}} present",
    "presentN_other": "{{count}} present",
    "absentN_one": "{{count}} absent",
    "absentN_other": "{{count}} absent",
    "lateN_one": "{{count}} late",
    "lateN_other": "{{count}} late",
    "saved": "Roll call recorded",
    "savedAt": "Recorded on {{date}} at {{time}}.",
    "edit": "Edit roll call",
    "backToList": "My sessions",
    "alreadyDone": "Roll call recorded on {{date}} at {{time}} — you can correct it.",
    "closed": "This roll call can no longer be changed.",
    "offline": "Offline: the roll call is kept on this phone and will be sent automatically.",
    "retrying": "Could not send yet: the roll call is kept on this phone and will be retried automatically.",
    "notFound": "This session does not exist or is not assigned to you.",
    "teacherAbsent": "Teacher absent: the session did not take place, there is no roll call."
  },
  "timetable": {
    "title": "Timetable",
    "subtitle": "Semester {{n}} · {{year}}",
    "print": "Print",
    "newSession": "New session",
    "view": "View",
    "modes": {
      "group": "Group",
      "teacher": "Teacher",
      "room": "Room",
      "overview": "Overview"
    },
    "notPlanned": "not published",
    "prevWeek": "Previous week",
    "nextWeek": "Next week",
    "today": "Today",
    "weekLabel": "Week {{week}} · {{from}} – {{to}}",
    "days": {
      "mon": "Mon",
      "tue": "Tue",
      "wed": "Wed",
      "thu": "Thu",
      "fri": "Fri",
      "sat": "Sat",
      "sun": "Sun"
    },
    "kinds": {
      "CM": "Lecture",
      "TD": "Tutorial",
      "TP": "Lab"
    },
    "roomKinds": {
      "amphi": "Lecture hall",
      "salle": "Room",
      "labo": "Lab"
    },
    "emptyTitle": "Timetable not published",
    "emptyText": "No session is scheduled this week.",
    "emptyStaff": "No session this week. Add one with “New session”.",
    "conflicts": "Conflicts",
    "noConflict": "No conflict detected.",
    "conflictTitle": {
      "room": "Room {{resource}} — {{day}} {{time}}",
      "teacher": "{{resource}} — {{day}} {{time}}",
      "group": "Group {{resource}} — {{day}} {{time}}"
    },
    "conflictDetail": "{{a}} and {{b}} overlap.",
    "conflict": {
      "room": "Room {{resource}} already used by {{group}} ({{course}})",
      "teacher": "{{resource}} already teaches {{group}} ({{course}})",
      "group": "Group {{resource}} already has {{course}}"
    },
    "freeRoom": "Suggested free room:",
    "reassign": "Reassign",
    "reassigned": "{{label}} moved to {{room}}. Students and teacher notified.",
    "selected": "Selected session",
    "selectHint": "Select a session in the grid to see its details.",
    "inConflict": "in conflict",
    "rollCall": "Take attendance",
    "openRollCall": "View attendance",
    "slot": {
      "newTitle": "New session",
      "editTitle": "Edit session",
      "group": "Group",
      "course": "Course",
      "teacher": "Teacher",
      "room": "Room",
      "day": "Day",
      "time": "Time slot",
      "kind": "Type",
      "conflictsTitle_one": "{{count}} conflict detected",
      "conflictsTitle_other": "{{count}} conflicts detected",
      "saveAnyway": "Save anyway",
      "created": "Session added to the timetable.",
      "updated": "Session updated. Upcoming sessions were updated.",
      "deleted": "Session deleted.",
      "deleteTitle": "Delete this recurring session?",
      "deleteText": "Every session of this slot without roll call (past ones included) is removed from the roll-call list. Roll calls already taken stay in the history.",
      "duplicate": "Duplicate",
      "duplicateTitle": "Duplicate the session",
      "customTime": "Custom time…",
      "start": "Start",
      "end": "End",
      "timeError": "The end must be after the start.",
      "window": "Taught from {{from}} to {{to}} (study plan).",
      "blockedTitle": "Teacher unavailable",
      "blocked": "The teacher already teaches {{group}} ({{course}}) at that time. A joint session is only possible between groups of the same level.",
      "jointSaved": "Joint session saved with {{groups}}: one class, one roll call per group."
    },
    "errors": {
      "generic": "Could not save. Try again.",
      "reference": "A selected item no longer exists. Reload the page.",
      "plan": "Validate the programme study plan before scheduling the timetable.",
      "time": "Invalid time (HH:MM).",
      "endBeforeStart": "End must be after start."
    },
    "legend": "Key:",
    "absent": "ABSENT",
    "level": "Level",
    "allLevels": "All levels",
    "prevDay": "Previous day",
    "nextDay": "Next day",
    "overviewTitle": "All groups — {{date}}",
    "jointWith": "Joint session with {{groups}}",
    "history": "Teacher history",
    "historySessions_one": "{{count}} session",
    "historySessions_other": "{{count}} sessions",
    "absence": {
      "badge": "Teacher absent",
      "mark": "Teacher absent",
      "clear": "Cancel absence",
      "marked": "Teacher absence recorded: the group is notified, the roll call is closed.",
      "cleared": "Absence cancelled: the roll call is possible again.",
      "rollCallDone": "The roll call of this session is already done."
    },
    "tags": {
      "title": "Tags",
      "hint": "Drag a course onto a free slot, a teacher or a room onto a session.",
      "courses": "Courses",
      "teachers": "Teachers",
      "rooms": "Rooms",
      "search": "Filter tags",
      "pickLevel": "Choose a level to see its courses.",
      "noCourse": "No course taught this semester.",
      "otherLevel": "This course is not taught in {{group}}.",
      "sameRow": "A session moves along its group row."
    }
  },
  "announcements": {
    "title": "Announcements",
    "subtitle": "Published in the student app, by audience.",
    "new": "New announcement",
    "publish": "Publish",
    "published": "Announcement published.",
    "failed": "Could not publish. Try again.",
    "deleted": "Announcement deleted.",
    "delete": "Delete “{{title}}”",
    "deleteTitle": "Delete this announcement?",
    "emptyTitle": "No announcements",
    "emptyText": "Published announcements appear here and in the student app.",
    "fields": {
      "title": "Title",
      "body": "Message",
      "kind": "Type",
      "audience": "Audience"
    },
    "kinds": {
      "info": "Information",
      "event": "Event",
      "warning": "Important",
      "room": "Room"
    },
    "audience": {
      "all": "All students",
      "program": "Programme",
      "level": "Level",
      "group": "Group"
    }
  },
  "notifications": {
    "weekdays": {
      "1": "Monday",
      "2": "Tuesday",
      "3": "Wednesday",
      "4": "Thursday",
      "5": "Friday",
      "6": "Saturday",
      "7": "Sunday"
    },
    "sessions": {
      "principale": "main",
      "rattrapage": "retake"
    },
    "absence": {
      "recorded": {
        "title": "Absence recorded — {{course}}",
        "body": "You have {{hours}} h to hand in a justification."
      },
      "alert": {
        "title": "Absences — {{course}}",
        "body": "Unexcused absence rate: {{pct}}."
      }
    },
    "timetable": {
      "room": {
        "title": "Room change — {{course}}",
        "body": "On {{day}} at {{time}}, the class takes place in {{room}}."
      },
      "conflict": {
        "title": "Room conflict",
        "body": "{{room}} · {{day}} {{time}} · {{groups}}"
      },
      "teacherAbsent": {
        "title": "Session cancelled — {{course}}",
        "body": "Teacher absent on {{at}}."
      }
    },
    "justification": {
      "approved": {
        "title": "Justification accepted",
        "body": "Your absences are justified."
      },
      "rejected": {
        "title": "Justification rejected",
        "body": "Please contact the registrar."
      }
    },
    "request": {
      "done": {
        "title": "{{kind}}: request handled",
        "body": "The document is available at the registrar or in your documents."
      },
      "rejected": {
        "title": "{{kind}}: request rejected",
        "body": "Please contact the registrar for details."
      }
    },
    "deliberation": {
      "pvToValidate": {
        "title": "Board minutes to approve",
        "body": "{{level}} · Semester {{semester}} · {{session}} session"
      }
    },
    "title": "For you",
    "empty": "No notifications.",
    "gradeReview": {
      "requested": {
        "title": "Grade check request",
        "body": "{{student}} · {{course}}"
      },
      "answered": {
        "title": "Answer to your grade check request",
        "body": "{{course}}: {{outcome}}"
      }
    },
    "internship": {
      "answers": {
        "accepted": "accepted",
        "refused": "refused",
        "assigned": "you are assigned"
      },
      "decision": {
        "title": "Internship subject: {{status}}",
        "body": "{{title}}"
      },
      "supervisionRequested": {
        "title": "Supervision request",
        "body": "{{title}}"
      },
      "supervisionAnswered": {
        "title": "Internship supervision",
        "body": "{{title}}: {{answer}}"
      },
      "defensePublished": {
        "title": "Defence date published",
        "body": "Your defence takes place on {{at}}."
      }
    }
  },
  "account": {
    "menu": "My account",
    "title": "My account",
    "passwordTitle": "Password",
    "passwordHint": "At least {{min}} characters. Your other sessions (other devices) will be signed out.",
    "current": "Current password",
    "new": "New password",
    "confirm": "Confirm the new password",
    "submit": "Change password",
    "passwordChanged": "Password changed. Your other sessions were signed out.",
    "errors": {
      "wrongPassword": "The current password is incorrect.",
      "generic": "Could not change the password. Try again in a moment."
    }
  },
  "audit": {
    "actions": {
      "absence_justify": "Absences justified",
      "absence_justify_reject": "Justification rejected",
      "absence_notify": "Absence alert sent",
      "announcement_create": "Announcement published",
      "announcement_delete": "Announcement deleted",
      "application_convert": "Application turned into an enrolment",
      "application_piece_upload": "Application document uploaded",
      "application_status": "Application status changed",
      "application_submit": "Application filed",
      "attendance_update": "Roll call changed",
      "auth_password_change": "Password changed",
      "auth_password_reset": "Password reset",
      "auth_refresh_reuse_detected": "Suspicious session closed",
      "curriculum_delete": "Curriculum deleted",
      "curriculum_new_version": "New curriculum version",
      "curriculum_publish": "Curriculum published",
      "document_issue": "Document issued",
      "document_revoke": "Document revoked",
      "document_send": "Document e-mailed",
      "document_request_done": "Document request handled",
      "document_request_rejected": "Document request rejected",
      "enrollment_create": "Enrolment confirmed",
      "enrollment_group_change": "Group changed",
      "enrollment_update": "Enrolment changed",
      "fee_schedule_apply": "Fee schedule applied",
      "fee_schedule_save": "Fee schedule changed",
      "grade_correction_request": "Grade correction requested",
      "grade_update": "Grade changed after saving",
      "grades_import": "Grades imported (Excel)",
      "grades_lock": "Grade sheet submitted",
      "grades_unlock": "Grade sheet reopened",
      "jury_decision": "Jury decision changed",
      "jury_pv": "Minutes generated",
      "jury_rattrapage_sheets": "Catch-up sheets created",
      "payment_cancel": "Payment cancelled",
      "payment_clear": "Payment cleared",
      "payment_create": "Payment recorded",
      "payment_reject": "Cheque rejected",
      "permissions_update": "Permissions changed",
      "platform_tenant_create": "School created",
      "program_create": "Programme created",
      "room_create": "Room created",
      "room_update": "Room changed",
      "student_create": "Student record created",
      "student_update": "Student record changed",
      "tenant_branding": "Branding changed",
      "tenant_logo": "Logo changed",
      "tenant_update": "School settings changed",
      "timetable_slot_delete": "Slot deleted",
      "timetable_slot_room": "Slot room reassigned",
      "year_activate": "Academic year opened",
      "year_archive": "Academic year archived",
      "year_create": "Academic year created",
      "year_delete": "Academic year deleted",
      "year_update": "Academic year changed",
      "platform_tenant_suspend": "School suspended",
      "platform_tenant_activate": "School reactivated",
      "platform_tenant_reinvite": "Administrator invitation resent",
      "platform_admin_reset": "Super admin password reset (server)",
      "platform_admin_create": "Super admin created (server)",
      "teacher_create": "Teacher record created",
      "teacher_update": "Teacher record changed",
      "teacher_export": "Teacher list exported (Excel)",
      "study_plan_period": "Teaching period changed",
      "study_plan_validate": "Study plan validated"
    },
    "entities": {
      "student": "Student",
      "grade_sheet": "Grade sheet",
      "jury": "Jury",
      "application": "Application",
      "user": "Account",
      "settings": "Settings",
      "academic_year": "Academic year",
      "curriculum": "Curriculum",
      "timetable_slot": "Timetable",
      "announcement": "Announcement",
      "tenant": "School",
      "attendance": "Attendance",
      "class_session": "Class session",
      "fee_schedule": "Fee schedule",
      "program": "Programme",
      "room": "Room",
      "teacher": "Teacher",
      "study_plan": "Study plan"
    },
    "title": "Audit trail",
    "subtitle": "Sensitive actions: who, what, when. Details stay on each record.",
    "columns": {
      "at": "Date",
      "actor": "By",
      "action": "Action",
      "record": "Record"
    },
    "search": "Person, student, student number…",
    "since": "Since",
    "empty": "No action recorded",
    "emptyText": "Change the filters or come back after the first sensitive actions."
  },
  "teachers": {
    "title": "Teachers",
    "subtitle": "Record, bank account and social affiliation. The Excel export keeps only active teachers who have a subject this year.",
    "new": "New teacher",
    "edit": "Edit teacher",
    "save": "Save",
    "export": "Export Excel",
    "empty": "No teachers",
    "created": "Teacher created. They set a password with « Forgot password ».",
    "updated": "Teacher record saved.",
    "noSubject": "No subject",
    "status": {
      "active": "Active",
      "disabled": "Inactive",
      "invited": "Invited"
    },
    "affiliation": {
      "cnss": "CNSS",
      "cnrps": "CNRPS",
      "none": "No affiliation"
    },
    "fields": {
      "firstName": "First name",
      "lastName": "Last name",
      "email": "E-mail",
      "cin": "National ID",
      "rib": "Bank account (RIB)",
      "affiliation": "Social affiliation",
      "affiliationNumber": "Affiliation number",
      "fiscalId": "Tax identifier",
      "active": "Active teacher"
    },
    "hints": {
      "cin": "8 digits.",
      "rib": "20 digits, no letters."
    },
    "errors": {
      "required": "Required field.",
      "email": "Please enter a valid e-mail address.",
      "cin": "The national ID must be 8 digits.",
      "rib": "The bank account must be exactly 20 digits.",
      "duplicateCin": "This national ID number already exists in the system.",
      "duplicateEmail": "This e-mail address is already used.",
      "affiliationNumber": "Enter the affiliation number.",
      "affiliationNone": "No number without an affiliation.",
      "generic": "Could not save. Check the record."
    }
  },
  "studyPlan": {
    "title": "Study plan",
    "open": "Study plan",
    "subtitle": "Year {{year}} — validate the plan before the timetable.",
    "next": "Continue",
    "createProgram": "New programme",
    "programCreated": "Programme created.",
    "addClass": "New class",
    "groupCreated": "Class created.",
    "noClass": "No class this year.",
    "addBasket": "New basket",
    "addSubject": "New subject",
    "emptyBasket": "Empty basket.",
    "saved": "Saved.",
    "validated": "Study plan validated.",
    "ready": "The plan is consistent. You can validate it.",
    "published": "This curriculum is published. Baskets and subjects change in a new version.",
    "openBuilder": "Open the curriculum",
    "filiereHint": "Create the programme, then attach its classes.",
    "classesHint": "Every year of the programme needs at least one class for the selected year.",
    "paniersHint": "Baskets (teaching units) group the subjects of a semester. Classes of the same year share them.",
    "subjectsHint": "Each subject has a weight and a hourly volume.",
    "datesHint": "Set a start date and an end date on every subject, inside the academic year.",
    "validationHint": "Check the programme, classes, baskets, weights, hours and dates before validating.",
    "validate": "Validate the study plan",
    "semester": "Semester {{n}}",
    "subjectMeta": "Weight {{weight}} · {{hours}} h",
    "status": {
      "missing": "Not started",
      "draft": "Draft",
      "validated": "Validated"
    },
    "steps": {
      "filiere": "Programme",
      "classes": "Classes",
      "paniers": "Baskets",
      "matieres": "Subjects",
      "dates": "Dates",
      "validation": "Validation"
    },
    "fields": {
      "program": "Programme",
      "semester": "Semester",
      "code": "Basket code",
      "name": "Name",
      "basket": "Basket",
      "weight": "Weight",
      "hours": "Hourly volume",
      "cm": "CM",
      "td": "TD",
      "tp": "TP",
      "startsOn": "Start",
      "endsOn": "End"
    },
    "issues": {
      "no_curriculum": "Create the programme curriculum first.",
      "credits": "Semester {{semester}} totals {{credits}} credits instead of {{target}}.",
      "empty_semester": "Semester {{semester}} has no basket.",
      "empty_unit": "Basket {{unit}} (semester {{semester}}) is empty.",
      "no_class": "No class for {{level}} this year.",
      "weight": "{{course}} has no weight.",
      "hours": "{{course}} has no hourly volume.",
      "dates": "{{course}} has no start and end dates.",
      "dates_order": "The end of {{course}} must be after the start.",
      "dates_outside": "The dates of {{course}} fall outside the academic year."
    },
    "errors": {
      "generic": "The operation failed. Try again.",
      "invalid": "The plan is not consistent yet.",
      "date": "Invalid date.",
      "order": "The end must be after the start."
    }
  },
  "calendar": {
    "title": "Academic calendar",
    "subtitle": "Start of year, holidays, exams, juries and defences · {{year}}",
    "new": "New event",
    "editTitle": "Edit event",
    "show": "Events shown",
    "upcoming": "Upcoming",
    "wholeYear": "Whole year",
    "now": "Ongoing",
    "created": "Event added to the calendar.",
    "updated": "Event updated.",
    "deleted": "Event deleted.",
    "deleteTitle": "Delete this event?",
    "edit": "Edit “{{title}}”",
    "delete": "Delete “{{title}}”",
    "emptyTitle": "The year's calendar is empty",
    "noUpcomingTitle": "No upcoming date",
    "emptyText": "The year's dates will appear here once the administration publishes them.",
    "emptyTextEditor": "Add the start of year, holidays, exam periods and juries: students and teachers see them in their space.",
    "fields": {
      "title": "Title",
      "kind": "Type",
      "audience": "Visible to",
      "startsOn": "From",
      "endsOn": "To (optional)",
      "description": "Details (optional)"
    },
    "kinds": {
      "start": "Start of year",
      "holiday": "Holiday",
      "exams": "Exams",
      "deliberation": "Jury",
      "defense": "Defences",
      "deadline": "Deadline",
      "event": "Event"
    },
    "audience": {
      "all": "Everyone",
      "students": "Students",
      "staff": "Staff and teachers"
    },
    "errors": {
      "title": "Enter a title.",
      "date": "Invalid date.",
      "range": "The end date must come after the start date."
    }
  },
  "gradeReviews": {
    "title": "Grade check requests",
    "subtitle": "Published marks that students ask to be checked",
    "backToSheets": "Grade sheets",
    "filter": "Requests shown",
    "answered": "Answered",
    "allSheets": "All sheets",
    "emptyPendingTitle": "No pending request",
    "emptyTitle": "No request",
    "emptyText": "Students can ask for a mark to be checked for a few days after the results are published.",
    "about": "{{course}} · {{group}} · S{{semester}} · {{session}} session",
    "openSheet": "Open the sheet",
    "answer": "Answer",
    "answerTitle": "Answer {{name}}",
    "outcome": "Outcome of the check",
    "correctHint": "Also correct the mark: in the grid if the sheet is a draft, through a correction request if it was submitted.",
    "response": "Answer to the student",
    "send": "Send the answer",
    "sent": "Answer sent to the student.",
    "pendingCount_one": "{{count}} pending request",
    "pendingCount_other": "{{count}} pending requests",
    "rowChip": "Check requested",
    "rowHint": "The student asked for this mark to be checked",
    "bannerTitle_one": "{{count}} pending check request",
    "bannerTitle_other": "{{count}} pending check requests",
    "bannerDraft": "Check the paper, correct the mark in the grid if needed, then answer the student.",
    "bannerLocked": "Check the paper; if the mark changes, file a correction request, then answer the student.",
    "answerRequests": "View and answer",
    "status": {
      "pending": "Pending",
      "maintained": "Mark confirmed",
      "corrected": "Mark corrected"
    },
    "errors": {
      "message": "Explain your request in a few words (at least 10 characters).",
      "response": "Write an answer."
    },
    "student": {
      "ask": "Ask for a check",
      "title": "Grade check request",
      "intro": "Do you think your mark in {{course}} is wrong (copying error, paper not counted…)? The teacher checks and answers you here.",
      "message": "Your request",
      "placeholder": "Example: my exam mark does not match my paper.",
      "helper": "Be precise: exam, test or lab concerned.",
      "send": "Send the request",
      "sent": "Request sent. You will be notified of the answer.",
      "window": "You can ask for a mark to be checked until {{date}}.",
      "status": {
        "pending": "Check requested",
        "maintained": "Answer: mark confirmed",
        "corrected": "Answer: mark corrected"
      },
      "errors": {
        "already_pending": "A request is already open for this mark.",
        "window": "The time to ask for a check is over.",
        "not_published": "The results of this session are not published yet.",
        "disabled": "Your school does not take check requests.",
        "failed": "The request could not be sent. Please try again."
      }
    }
  },
  "internships": {
    "title": "Internships & final projects",
    "myTitle": "My supervisions",
    "subtitle": "Subjects, supervision, deposits and defences of the year",
    "new": "New internship",
    "newHint": "An internship created by the registrar is approved at once: the agreement is issued and the supervisor assigned.",
    "create": "Create the internship",
    "created": "Internship {{code}} created.",
    "editTitle": "Edit the internship",
    "saved": "Internship saved.",
    "notFound": "Internship not found",
    "pfe": "Final project",
    "search": "Subject, company, student or ID",
    "allTypes": "All kinds",
    "allStatuses": "All statuses",
    "roleFilter": "Internships shown",
    "roles": {
      "supervisor": "I supervise",
      "requests": "Supervision requests",
      "jury": "My juries"
    },
    "emptyTitle": "No internship this year",
    "emptyText": "Students declare their internships from their space; the registrar can also create them.",
    "emptyRole": {
      "supervisor": "You supervise no internship",
      "requests": "No supervision request",
      "jury": "No jury yet"
    },
    "emptyTeacherText": "Students can propose you as supervisor; you then get a notification.",
    "tabs": {
      "list": "Internships",
      "sessions": "Defences",
      "types": "Kinds"
    },
    "columns": {
      "code": "Reference",
      "title": "Subject",
      "students": "Students",
      "supervisor": "Supervisor",
      "documents": "Deposits",
      "defense": "Defence",
      "status": "Status"
    },
    "status": {
      "proposed": "Proposed",
      "to_revise": "To revise",
      "approved": "Approved",
      "refused": "Refused"
    },
    "supervision": {
      "none": "None",
      "pending": "Pending",
      "accepted": "Accepted",
      "refused": "Refused"
    },
    "documents": {
      "report": "Report",
      "certificate": "Internship certificate",
      "plagiarism": "Plagiarism report",
      "logbook": "Logbook",
      "company_evaluation": "Company evaluation"
    },
    "sections": {
      "subject": "Subject",
      "company": "Host organisation",
      "students": "Students",
      "supervision": "Academic supervision",
      "deposits": "Deposits",
      "defense": "Defence"
    },
    "fields": {
      "type": "Kind",
      "title": "Subject title",
      "description": "Goals and expected work",
      "startsOn": "Start",
      "endsOn": "End",
      "period": "Period",
      "companyName": "Company or organisation",
      "companyCity": "City",
      "companyAddress": "Address",
      "companySupervisorName": "Company supervisor",
      "companySupervisorEmail": "Supervisor e-mail",
      "companySupervisorPhone": "Supervisor phone",
      "contact": "Contact",
      "supervisor": "Academic supervisor",
      "supervisorHint": "The teacher gets a supervision request to accept.",
      "students_one": "Student",
      "students_other": "Students (up to {{count}})",
      "studentsMax_one": "One student for this kind",
      "studentsMax_other": "{{count}} students at most",
      "studentsHint": "Type at least 2 letters of the name or ID",
      "noStudent": "No student found"
    },
    "noSupervisor": "No supervisor yet",
    "noDescription": "No description.",
    "assignSupervisor": "Assign the supervisor",
    "changeSupervisor": "Change supervisor",
    "supervisorSaved": "Supervisor assigned.",
    "supervisionRequest": "A student proposes that you supervise this internship.",
    "acceptSupervision": "Accept supervision",
    "refuseSupervision": "Refuse",
    "supervisionAccepted": "Supervision accepted: the student is told.",
    "supervisionRefused": "Supervision refused: the student is told.",
    "decide": "Decision on the subject",
    "decision": "Decision",
    "confirmDecision": "Save the decision",
    "approveHint": "The internship agreement is issued on approval; each student finds it in their documents.",
    "reason": "Comment (optional)",
    "reasonRequired": "Reason (shared with the student)",
    "decided": {
      "approved": "Subject approved: the agreement is issued.",
      "to_revise": "Subject sent back to the student for revision.",
      "refused": "Subject refused."
    },
    "issueConvention": "Issue the agreement",
    "conventionIssued": "Agreement issued.",
    "depositAfterApproval": "Deposits open once the subject is approved.",
    "depositClosed": "Deposits are closed (outside the deposit period).",
    "notDeposited": "Not deposited yet",
    "deposit": "Deposit",
    "replace": "Replace",
    "view": "View",
    "deposited": "Document deposited.",
    "noDefense": "Defence not scheduled yet.",
    "grade": "Mark",
    "gradeSaved": "Mark saved.",
    "jury": {
      "president": "Jury president",
      "reviewer": "Reviewer",
      "supervisor": "Supervisor",
      "guest": "Guest",
      "line": "President: {{president}} · Reviewer: {{reviewer}} · Supervisor: {{supervisor}}",
      "supervisorHint": "The academic supervisor sits by right; they can be neither president nor reviewer."
    },
    "clashes": {
      "room": "Room already used by “{{title}}” ({{time}})",
      "president": "The president already sits on “{{title}}” ({{time}})",
      "reviewer": "The reviewer already sits on “{{title}}” ({{time}})",
      "supervisor": "The supervisor is busy with “{{title}}” ({{time}})",
      "student": "A student already defends “{{title}}” ({{time}})"
    },
    "sessions": {
      "intro": "A session sets the defence period and, before it, the period to deposit reports.",
      "new": "New session",
      "editTitle": "Edit the session",
      "created": "Session created.",
      "updated": "Session updated.",
      "allTypes": "All kinds",
      "depositUntil": "deposit until {{date}}",
      "counts": "{{scheduled}} scheduled · {{published}} published",
      "emptyTitle": "No defence session",
      "emptyText": "Create a session to schedule the defences and open the deposits.",
      "fields": {
        "title": "Title",
        "startsOn": "Defences from",
        "endsOn": "to",
        "depositFrom": "Deposit from",
        "depositUntil": "Deposit until",
        "date": "Date",
        "time": "Time",
        "room": "Room"
      },
      "depositHint": "Without a deposit period, students deposit as soon as their subject is approved.",
      "publish": "Publish the defences",
      "unpublish": "Withdraw publication",
      "publishedToast": "Defences published: students are told.",
      "unpublishedToast": "Publication withdrawn.",
      "notPublished": "Defences are not published yet: students see neither the date nor the jury.",
      "published": "Published",
      "draft": "Not published",
      "scheduled_one": "{{count}} defence scheduled",
      "scheduled_other": "{{count}} defences scheduled",
      "toSchedule_one": "{{count}} internship to schedule",
      "toSchedule_other": "{{count}} internships to schedule",
      "noneScheduled": "No defence scheduled",
      "noneScheduledText": "Schedule the approved internships listed below.",
      "noCandidate": "No approved internship waiting for a defence in this session.",
      "ready": "File complete",
      "missing": "Missing: {{list}}",
      "schedule": "Schedule",
      "reschedule": "Edit the defence",
      "scheduledToast": "Defence scheduled.",
      "warningTitle": "To check before scheduling",
      "force": "Schedule anyway",
      "editDefense": "Edit the defence “{{title}}”",
      "deleteDefense": "Delete the defence “{{title}}”",
      "deleteDefenseTitle": "Delete this defence?"
    },
    "types": {
      "intro": "Each kind (summer internship, final project…) sets the levels concerned, team size, documents to deposit and the defence.",
      "new": "New kind",
      "editTitle": "Edit the kind",
      "created": "Kind created.",
      "updated": "Kind updated.",
      "deleted": "Kind deleted.",
      "deleteTitle": "Delete this kind?",
      "edit": "Edit “{{name}}”",
      "delete": "Delete “{{name}}”",
      "duplicate": "A kind already has this name.",
      "usedHint_one": "{{count}} internship uses it: deactivate it instead",
      "usedHint_other": "{{count}} internships use it: deactivate it instead",
      "inactive": "Inactive",
      "allLevels": "All levels",
      "weeks_one": "{{count}} week",
      "weeks_other": "{{count}} weeks",
      "team_one": "Individual",
      "team_other": "Team of up to {{count}}",
      "defense_one": "{{count}}-min defence",
      "defense_other": "{{count}}-min defence",
      "noDefense": "No defence",
      "declarable": "declared by the student",
      "byOffice": "created by the registrar",
      "emptyTitle": "No internship kind",
      "emptyText": "Create at least one kind (e.g. “Summer internship” and “Final project”) so internships can be declared.",
      "fields": {
        "name": "Name",
        "levels": "Levels concerned",
        "levelsHint": "No level selected: every level.",
        "weeks": "Length (weeks)",
        "team": "Students per internship",
        "minutes": "Defence length (min)",
        "isPfe": "Final-year project",
        "declarable": "Students declare their own internship",
        "companySupervisor": "Company supervisor required (name and e-mail)",
        "hasDefense": "Defence before a jury",
        "active": "Active (offered for new internships)",
        "required": "Documents to deposit before the defence"
      }
    },
    "errors": {
      "invalid": "Check the form fields.",
      "type": "Choose the kind of internship.",
      "title": "Enter a title (at least 5 characters).",
      "name": "Enter a name.",
      "company": "Enter the host company or organisation.",
      "date": "Invalid date.",
      "range": "The end date must come after the start date.",
      "phone": "Invalid phone.",
      "email": "Invalid e-mail.",
      "reason": "Give the reason.",
      "students": "Choose at least one student.",
      "team_size": "Too many students for this kind.",
      "company_supervisor": "The company supervisor's name and e-mail are required for this kind.",
      "already": "An internship of this kind already exists this year.",
      "level": "This kind does not concern this level.",
      "not_enrolled": "Student not enrolled this year.",
      "not_teacher": "Choose a teacher of the school.",
      "not_declarable": "This internship is recorded by the registrar.",
      "inactive": "This kind is no longer offered.",
      "decided": "The subject is already approved: contact the registrar to change it.",
      "graded": "The internship is already marked.",
      "supervision": "A supervision request is already open.",
      "not_approved": "The subject is not approved yet.",
      "closed": "The deposit period is closed.",
      "too_large": "File too large (10 MB at most).",
      "type_file": "Format not accepted: PDF, JPEG or PNG.",
      "empty": "No file sent.",
      "upload": "The deposit failed. Please try again.",
      "jury": "The president, the reviewer and the supervisor must be three different people.",
      "outside_session": "The date is outside the session period.",
      "session": "This internship does not belong to this session.",
      "already_scheduled": "This internship already has a defence.",
      "president": "Choose the jury president.",
      "reviewer": "Choose the reviewer."
    }
  }
}
